(() => {
  var __create = Object.create;
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __getProtoOf = Object.getPrototypeOf;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __commonJS = (cb, mod) => function __require() {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
    // If the importer is in node compatibility mode or this is not an ESM
    // file that has been converted to a CommonJS file using a Babel-
    // compatible transform (i.e. "__esModule" has not been set), then set
    // "default" to the CommonJS "module.exports" for node compatibility.
    isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
    mod
  ));

  // node_modules/zenscroll/zenscroll.js
  var require_zenscroll = __commonJS({
    "node_modules/zenscroll/zenscroll.js"(exports, module) {
      (function(root, factory) {
        if (typeof define === "function" && define.amd) {
          define([], factory());
        } else if (typeof module === "object" && module.exports) {
          module.exports = factory();
        } else {
          (function install() {
            if (document && document.body) {
              root.zenscroll = factory();
            } else {
              setTimeout(install, 9);
            }
          })();
        }
      })(exports, function() {
        "use strict";
        var isNativeSmoothScrollEnabledOn = function(elem) {
          return elem && "getComputedStyle" in window && window.getComputedStyle(elem)["scroll-behavior"] === "smooth";
        };
        if (typeof window === "undefined" || !("document" in window)) {
          return {};
        }
        var makeScroller = function(container, defaultDuration, edgeOffset) {
          defaultDuration = defaultDuration || 999;
          if (!edgeOffset && edgeOffset !== 0) {
            edgeOffset = 9;
          }
          var scrollTimeoutId;
          var setScrollTimeoutId = function(newValue) {
            scrollTimeoutId = newValue;
          };
          var stopScroll = function() {
            clearTimeout(scrollTimeoutId);
            setScrollTimeoutId(0);
          };
          var getTopWithEdgeOffset = function(elem) {
            return Math.max(0, container.getTopOf(elem) - edgeOffset);
          };
          var scrollToY = function(targetY, duration, onDone) {
            stopScroll();
            if (duration === 0 || duration && duration < 0 || isNativeSmoothScrollEnabledOn(container.body)) {
              container.toY(targetY);
              if (onDone) {
                onDone();
              }
            } else {
              var startY = container.getY();
              var distance = Math.max(0, targetY) - startY;
              var startTime = (/* @__PURE__ */ new Date()).getTime();
              duration = duration || Math.min(Math.abs(distance), defaultDuration);
              (function loopScroll() {
                setScrollTimeoutId(setTimeout(function() {
                  var p = Math.min(1, ((/* @__PURE__ */ new Date()).getTime() - startTime) / duration);
                  var y = Math.max(0, Math.floor(startY + distance * (p < 0.5 ? 2 * p * p : p * (4 - p * 2) - 1)));
                  container.toY(y);
                  if (p < 1 && container.getHeight() + y < container.body.scrollHeight) {
                    loopScroll();
                  } else {
                    setTimeout(stopScroll, 99);
                    if (onDone) {
                      onDone();
                    }
                  }
                }, 9));
              })();
            }
          };
          var scrollToElem = function(elem, duration, onDone) {
            scrollToY(getTopWithEdgeOffset(elem), duration, onDone);
          };
          var scrollIntoView = function(elem, duration, onDone) {
            var elemHeight = elem.getBoundingClientRect().height;
            var elemBottom = container.getTopOf(elem) + elemHeight;
            var containerHeight = container.getHeight();
            var y = container.getY();
            var containerBottom = y + containerHeight;
            if (getTopWithEdgeOffset(elem) < y || elemHeight + edgeOffset > containerHeight) {
              scrollToElem(elem, duration, onDone);
            } else if (elemBottom + edgeOffset > containerBottom) {
              scrollToY(elemBottom - containerHeight + edgeOffset, duration, onDone);
            } else if (onDone) {
              onDone();
            }
          };
          var scrollToCenterOf = function(elem, duration, offset, onDone) {
            scrollToY(Math.max(0, container.getTopOf(elem) - container.getHeight() / 2 + (offset || elem.getBoundingClientRect().height / 2)), duration, onDone);
          };
          var setup = function(newDefaultDuration, newEdgeOffset) {
            if (newDefaultDuration === 0 || newDefaultDuration) {
              defaultDuration = newDefaultDuration;
            }
            if (newEdgeOffset === 0 || newEdgeOffset) {
              edgeOffset = newEdgeOffset;
            }
            return {
              defaultDuration,
              edgeOffset
            };
          };
          return {
            setup,
            to: scrollToElem,
            toY: scrollToY,
            intoView: scrollIntoView,
            center: scrollToCenterOf,
            stop: stopScroll,
            moving: function() {
              return !!scrollTimeoutId;
            },
            getY: container.getY,
            getTopOf: container.getTopOf
          };
        };
        var docElem = document.documentElement;
        var getDocY = function() {
          return window.scrollY || docElem.scrollTop;
        };
        var zenscroll2 = makeScroller({
          body: document.scrollingElement || document.body,
          toY: function(y) {
            window.scrollTo(0, y);
          },
          getY: getDocY,
          getHeight: function() {
            return window.innerHeight || docElem.clientHeight;
          },
          getTopOf: function(elem) {
            return elem.getBoundingClientRect().top + getDocY() - docElem.offsetTop;
          }
        });
        zenscroll2.createScroller = function(scrollContainer, defaultDuration, edgeOffset) {
          return makeScroller({
            body: scrollContainer,
            toY: function(y) {
              scrollContainer.scrollTop = y;
            },
            getY: function() {
              return scrollContainer.scrollTop;
            },
            getHeight: function() {
              return Math.min(scrollContainer.clientHeight, window.innerHeight || docElem.clientHeight);
            },
            getTopOf: function(elem) {
              return elem.offsetTop;
            }
          }, defaultDuration, edgeOffset);
        };
        if ("addEventListener" in window && !window.noZensmooth && !isNativeSmoothScrollEnabledOn(document.body)) {
          var isHistorySupported = "history" in window && "pushState" in history;
          var isScrollRestorationSupported = isHistorySupported && "scrollRestoration" in history;
          if (isScrollRestorationSupported) {
            history.scrollRestoration = "auto";
          }
          window.addEventListener("load", function() {
            if (isScrollRestorationSupported) {
              setTimeout(function() {
                history.scrollRestoration = "manual";
              }, 9);
              window.addEventListener("popstate", function(event) {
                if (event.state && "zenscrollY" in event.state) {
                  zenscroll2.toY(event.state.zenscrollY);
                }
              }, false);
            }
            if (window.location.hash) {
              setTimeout(function() {
                var edgeOffset = zenscroll2.setup().edgeOffset;
                if (edgeOffset) {
                  var targetElem = document.getElementById(window.location.href.split("#")[1]);
                  if (targetElem) {
                    var targetY = Math.max(0, zenscroll2.getTopOf(targetElem) - edgeOffset);
                    var diff = zenscroll2.getY() - targetY;
                    if (0 <= diff && diff < 9) {
                      window.scrollTo(0, targetY);
                    }
                  }
                }
              }, 9);
            }
          }, false);
          var RE_noZensmooth = new RegExp("(^|\\s)noZensmooth(\\s|$)");
          window.addEventListener("click", function(event) {
            var anchor = event.target;
            while (anchor && anchor.tagName !== "A") {
              anchor = anchor.parentNode;
            }
            if (!anchor || event.which !== 1 || event.shiftKey || event.metaKey || event.ctrlKey || event.altKey) {
              return;
            }
            if (isScrollRestorationSupported) {
              var historyState = history.state && typeof history.state === "object" ? history.state : {};
              historyState.zenscrollY = zenscroll2.getY();
              try {
                history.replaceState(historyState, "");
              } catch (e) {
              }
            }
            var href = anchor.getAttribute("href") || "";
            if (href.indexOf("#") === 0 && !RE_noZensmooth.test(anchor.className)) {
              var targetY = 0;
              var targetElem = document.getElementById(href.substring(1));
              if (href !== "#") {
                if (!targetElem) {
                  return;
                }
                targetY = zenscroll2.getTopOf(targetElem);
              }
              event.preventDefault();
              var onDone = function() {
                window.location = href;
              };
              var edgeOffset = zenscroll2.setup().edgeOffset;
              if (edgeOffset) {
                targetY = Math.max(0, targetY - edgeOffset);
                if (isHistorySupported) {
                  onDone = function() {
                    history.pushState({}, "", href);
                  };
                }
              }
              zenscroll2.toY(targetY, null, onDone);
            }
          }, false);
        }
        return zenscroll2;
      });
    }
  });

  // app/scripts/utils/addEvent.js
  function addEvent(evt, selector, handler) {
    evt.split(" ").forEach((event) => {
      document.addEventListener(
        event,
        function(event2) {
          if (event2.target.matches(selector + ", " + selector + " *")) {
            handler.apply(event2.target.closest(selector), arguments);
          }
        },
        false
      );
    });
  }

  // app/scripts/utils/debounceTime.js
  function debounceTime(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  // app/scripts/utils/resizeObserver.js
  function resizeObserver(selector, callback, debounceTimeout = 300) {
    const { debounceTime: debounceTime4 } = theme;
    let lastWidth = selector.clientWidth;
    const debounce = debounceTime4((e) => {
      let newestWidth = selector.clientWidth;
      if (newestWidth == lastWidth)
        return;
      callback.apply(selector);
      lastWidth = newestWidth;
    }, debounceTimeout);
    if ("ResizeObserver" in window) {
      const resizeObserver2 = new ResizeObserver((entries) => {
        debounce.call(selector);
      });
      resizeObserver2.observe(selector);
    } else {
      window.addEventListener("resize", () => debounce.bind(selector));
    }
  }

  // app/scripts/utils/inViewPort.js
  function inViewPort(el, callback, once = false) {
    if (!el || typeof callback !== "function")
      return;
    const options = {
      root: null,
      // viewport
      rootMargin: "0px",
      threshold: 0
      // trigger when element first appears in viewport
    };
    const observer = new IntersectionObserver((entries) => {
      const isIntersecting = entries[0].isIntersecting;
      callback(isIntersecting, entries);
      if (isIntersecting && once) {
        observer.disconnect();
      }
    }, options);
    observer.observe(el);
    return () => observer.disconnect();
  }

  // app/scripts/utils/scroll.js
  var import_zenscroll = __toESM(require_zenscroll(), 1);
  function scroll(selector, duration = 500, offset = 0) {
    const headerSticky = document.querySelector("sticky-header");
    const headerHeight = headerSticky?.getBoundingClientRect().bottom || 0;
    let adjustedOffset = offset;
    if (headerHeight > 0) {
      adjustedOffset = offset - headerHeight;
    }
    const top = selector.offsetTop + adjustedOffset;
    import_zenscroll.default.toY(top, duration);
  }

  // app/scripts/utils/countDecimals.js
  function countDecimals(value) {
    if (Math.floor(value) === value)
      return 0;
    return value.toString().split(".")[1]?.length || 0;
  }

  // app/scripts/utils/checkAndUpdateQuantity.js
  function checkAndUpdateQuantity(data, price, quantity) {
    const newData = JSON.parse(JSON.stringify(data));
    if (countDecimals(price) > 2) {
      newData.properties._quantity = String(quantity);
      newData.properties._unitPrice = String(price);
      newData.quantity = 1;
    } else {
      newData.quantity = quantity;
      delete newData.properties._quantity;
    }
    return newData;
  }

  // app/scripts/utils/dispatchEvent.js
  function dispatchEvent(event, options, elm) {
    return elm ? elm.dispatchEvent(event, options) : document.dispatchEvent(event, options);
  }

  // app/scripts/utils/disableScroll.js
  function disableScroll() {
    document.body.classList.add("overflow-hidden");
    document.documentElement.style.paddingRight = "var(--scrollbar-width)";
  }

  // app/scripts/utils/enableScroll.js
  function enableScroll() {
    setTimeout(() => {
      document.body.classList.remove("overflow-hidden");
      document.documentElement.style.paddingRight = "";
    }, 50);
  }

  // app/scripts/utils/calcHeaderBottom.js
  var updateHeaderBottom = () => {
    const themeHeader = document.getElementById("theme-header");
    const rect = themeHeader.getBoundingClientRect();
    document.body.style.setProperty("--theme-header-bottom", `${rect.bottom + window.scrollY}px`);
  };
  var calcHeaderBottom_default = updateHeaderBottom;

  // app/scripts/sections/header.js
  var SCROLL_THRESHOLD = 50;
  var section = {
    type: "header",
    onLoad() {
    },
    onSelect() {
    },
    onDeselect(evt) {
    },
    onBlockSelect(e) {
    },
    onBlockDeselect(e) {
    },
    onMegaMenuResize() {
      const menu = this.container.querySelector('[data-section-type="mega-menu"]');
      const header = document.getElementById("theme-header");
      if (!menu || !header)
        return;
      const defaultMenuHeight = parseInt(menu.dataset.menuHeight, 10) || 620;
      const headerHeight = header.offsetHeight;
      const viewportHeight = window.innerHeight;
      let newHeight = defaultMenuHeight;
      const availableHeight = viewportHeight - headerHeight - 100;
      if (availableHeight < defaultMenuHeight) {
        newHeight = Math.max(availableHeight, 320);
      }
      menu.style.setProperty("--height", `${newHeight}px`);
    },
    init() {
      this.container = document.querySelector(`[data-section-type="${this.type}"]`);
      if (!this.container)
        return;
      this.cart = this.container?.querySelector("header-cart");
      const mobileSearchMode = this.container.dataset.visibility;
      const themeHeader = this.themeHeader = document.getElementById("theme-header");
      if (themeHeader && theme.editor) {
        calcHeaderBottom_default();
        const resizeObserver2 = new ResizeObserver(calcHeaderBottom_default);
        resizeObserver2.observe(themeHeader);
      }
      themeHeader.addEventListener("click", (e) => {
        const { target } = e;
        const button = target.closest("button");
        if (button) {
          themeHeader.querySelectorAll("button.show").forEach((btn) => {
            button != btn && btn.classList.remove("show");
          });
          button.classList.toggle("show");
        }
        const mainNav = target.closest(".toggle-button");
        const currentMegaMenu = mainNav?.closest(".toggle-mega-menu");
        const megaMenu = target.closest("mega-menu");
        const dropdownMegaMenu = target.closest(".dropdown-mega-menu");
        if (mainNav) {
          e.stopPropagation();
          if (!(megaMenu || dropdownMegaMenu)) {
            document.querySelectorAll(".toggle-mega-menu").forEach((menu) => {
              if (menu !== currentMegaMenu) {
                menu.classList.remove("show");
                themeHeader.querySelectorAll("button.show").forEach((btn) => {
                  if (button !== btn)
                    btn.classList.remove("show");
                });
              }
            });
            currentMegaMenu.classList.toggle("show");
          }
        } else {
          if (!(megaMenu || dropdownMegaMenu)) {
            document.querySelectorAll(".toggle-mega-menu").forEach((menu) => {
              menu.classList.remove("show");
            });
            themeHeader.querySelectorAll("button.show").forEach((btn) => {
              if (btn !== button)
                btn.classList.remove("show");
            });
          }
        }
        document.addEventListener("click", (e2) => {
          const target2 = e2.target;
          const isInsideHeader = themeHeader.contains(target2);
          const isMegaMenu = target2.closest("mega-menu");
          const isDropdown = target2.closest(".dropdown-mega-menu");
          if (!isInsideHeader && !isMegaMenu && !isDropdown) {
            document.querySelectorAll(".toggle-mega-menu").forEach((menu) => {
              menu.classList.remove("show");
            });
            themeHeader.querySelectorAll("button.show").forEach((btn) => {
              btn.classList.remove("show");
            });
          }
        });
      });
      this.container.querySelectorAll(".jsNavMega").forEach((a) => {
        a.addEventListener("mouseenter", this.onNavHover.bind(this, a), { once: true });
        a.addEventListener("focusin", (e) => {
          a.closest("li").classList.add("is-focusing");
          this.onNavHover(a);
        });
        a.addEventListener("focusout", (e) => {
          setTimeout(() => {
            !a.closest("li").querySelectorAll(".is-focusing").length && a.closest("li").classList.remove("is-focusing");
          }, 100);
        });
      });
      this.onMegaMenuResize();
      window.addEventListener("resize", this.debounce(this.onMegaMenuResize.bind(this), 250));
      this.initHeaderIcons();
      mobileSearchMode == "minimize" && this.initScrollDetection();
    },
    initHeaderIcons() {
      const buttons = this.container.querySelectorAll(".js-header-icon");
      buttons.forEach((button) => {
        button.addEventListener("click", (e) => {
          e.preventDefault();
          buttons.forEach((btn) => btn.parentElement.classList.remove("show"));
          button.parentElement.classList.toggle("show", !button.classList.contains("show"));
        });
      });
      document.addEventListener("click", (e) => {
        buttons.forEach((btn) => !btn.parentElement.contains(e.target) && btn.parentElement.classList.remove("show"));
      });
    },
    onNavHover(el) {
      const nav = el;
      const template = nav.parentNode.querySelector(".jsTemplate");
      if (!template)
        return;
      template.tagName == "TEMPLATE" && Array.from(template.content.children)?.forEach((child) => {
        template.insertAdjacentElement("beforebegin", child);
      });
      template.tagName == "NOSCRIPT" && template.insertAdjacentHTML("beforebegin", template.textContent);
      template.remove();
      const parentNode = nav.parentNode;
      parentNode.classList.add("has-dropdown");
      parentNode.classList.toggle("has-mega-menu", parentNode.querySelector('[data-section-type="mega-menu"]'));
      parentNode.querySelector(":scope > a ~ template")?.remove();
      parentNode.querySelectorAll("a").forEach((a) => {
        a.addEventListener("focusin", (e) => {
          a.classList.add("is-focusing");
        });
        a.addEventListener("focusout", (e) => {
          a.classList.remove("is-focusing");
          setTimeout(() => {
            !parentNode.querySelectorAll(".is-focusing").length && parentNode.classList.remove("is-focusing");
          }, 100);
        });
      });
      this.calHeight();
    },
    calHeight() {
      this.container.querySelectorAll(".jsCalHeight").forEach((item) => {
        item.style.setProperty("--menu-height", item.firstElementChild.scrollHeight + "px");
      });
    },
    // Scroll detection function
    initScrollDetection() {
      let lastScrollY = window.scrollY;
      let isScrollingDown = false;
      let firstScroll = true;
      const coveoSearchForm = this.themeHeader.querySelector(".js-coveo-search-form");
      const iconSearch = this.themeHeader.querySelector(".js-icon-search");
      if (!coveoSearchForm || !iconSearch) {
        console.warn("Search form or icon search not found");
        return;
      }
      iconSearch.addEventListener("click", () => {
        this.themeHeader.classList.remove("scrolled-down");
        lastScrollY = window.scrollY;
        isScrollingDown = false;
      });
      window.addEventListener("scroll", () => {
        if (window.innerWidth > 990)
          return;
        const currentScrollY = window.scrollY;
        if (Math.abs(currentScrollY - lastScrollY) < SCROLL_THRESHOLD)
          return;
        if (firstScroll) {
          firstScroll = false;
          lastScrollY = currentScrollY;
          return;
        }
        if (currentScrollY > lastScrollY) {
          if (!isScrollingDown) {
            isScrollingDown = true;
            this.onScrollDown();
          }
        } else if (currentScrollY < lastScrollY) {
          if (isScrollingDown) {
            isScrollingDown = false;
          }
        }
        lastScrollY = currentScrollY;
      });
    },
    onScrollDown() {
      this.themeHeader.classList.add("scrolled-down");
    },
    onScrollUp() {
      this.themeHeader.classList.remove("scrolled-down");
    },
    debounce(fn, delay4) {
      let timer;
      return function(...args) {
        clearTimeout(timer);
        timer = setTimeout(() => fn.apply(this, args), delay4);
      };
    }
  };

  // app/scripts/utils/delay.js
  function delay(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  // app/scripts/modules/drawer-management.js
  var DrawerManagement = class {
    constructor() {
      this.drawers = [...document.querySelectorAll(".drawer")].reduce((previousValue, drawer) => {
        const id = drawer.id;
        if (!previousValue[id]) {
          previousValue[id] = drawer;
        }
        return previousValue;
      }, {});
      this.cart = this.drawers["cart-drawer"];
    }
    open(id) {
      this.drawers[id].open();
    }
    close(id) {
      this.drawers[id].close();
    }
  };

  // app/scripts/utils/debounceEvent.js
  var debouncedEventDispatcher = /* @__PURE__ */ (() => {
    const timeouts = /* @__PURE__ */ new Map();
    const DEFAULT_DELAY = 300;
    return {
      dispatch(eventName, detail = {}, delay4 = DEFAULT_DELAY) {
        if (timeouts.has(eventName)) {
          clearTimeout(timeouts.get(eventName));
        }
        const timeout = setTimeout(() => {
          try {
            window.dispatchEvent(new CustomEvent(eventName, { detail }));
          } catch (error) {
            console.error(`Error dispatching ${eventName}:`, error);
          }
          timeouts.delete(eventName);
        }, delay4);
        timeouts.set(eventName, timeout);
      },
      clear(eventName) {
        if (timeouts.has(eventName)) {
          clearTimeout(timeouts.get(eventName));
          timeouts.delete(eventName);
        }
      },
      clearAll() {
        timeouts.forEach((timeout) => clearTimeout(timeout));
        timeouts.clear();
      }
    };
  })();
  var debounceEvent_default = debouncedEventDispatcher;

  // app/scripts/utils/handleQueue.js
  async function handleQueue(callback) {
    try {
      await new Promise((resolve) => {
        requestAnimationFrame(async () => {
          await callback();
          resolve();
        });
      });
    } catch (error) {
      console.error(error);
    } finally {
    }
  }

  // app/scripts/utils/storage.js
  function localStorage2(storageKey, defaultValue = []) {
    const key = storageKey;
    const storage = {
      get: () => {
        try {
          const data = window.localStorage.getItem(key);
          return data ? JSON.parse(data) : defaultValue;
        } catch (error) {
          console.error(`Error getting item from localStorage: ${error.message}`);
          return defaultValue;
        }
      },
      set: (value, options = {}) => {
        try {
          const currentValue = storage.get();
          if (JSON.stringify(currentValue) === JSON.stringify(value)) {
            return;
          }
          const data = { value };
          if (options.expire) {
            data.expire = Date.now() + 24 * 60 * 60 * 1e3 * options.expire;
          }
          window.localStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
          console.error(`Error setting item in localStorage: ${error.message}`);
          throw error;
        }
      },
      clear: () => {
        try {
          window.localStorage.removeItem(key);
        } catch (error) {
          console.error(`Error clearing item from localStorage: ${error.message}`);
          throw error;
        }
      },
      eventDispatch: () => {
        window.dispatchEvent(
          new CustomEvent(`localStorage:${key}:change`, {
            bubbles: true,
            detail: { key }
          })
        );
      }
    };
    return storage;
  }
  function sessionStorage(storageKey) {
    const key = storageKey;
    const sessionStore = window.sessionStorage;
    const storage = {
      get: () => {
        try {
          const data = sessionStore.getItem(key);
          return data ? JSON.parse(data) : null;
        } catch (error) {
          console.error(`Error getting item from sessionStorage: ${error.message}`);
          return null;
        }
      },
      set: (value) => {
        try {
          sessionStore.setItem(key, JSON.stringify(value));
        } catch (error) {
          console.error(`Error setting item in sessionStorage: ${error.message}`);
          throw error;
        }
      },
      clear: () => {
        try {
          sessionStore.removeItem(key);
        } catch (error) {
          console.error(`Error clearing item from sessionStorage: ${error.message}`);
          throw error;
        }
      }
    };
    return storage;
  }

  // app/scripts/utils/getVariantsInfo.js
  var CACHE_TTL_MS = 5 * 60 * 1e3;
  var cache = /* @__PURE__ */ new Map();
  var inFlight = /* @__PURE__ */ new Map();
  var generation = 0;
  var invalidate = () => {
    cache.clear();
    generation++;
  };
  window.addEventListener("preferredLocation:change", invalidate);
  window.addEventListener("regionUpdated", invalidate);
  window.addEventListener("deliveryMethod:change", invalidate);
  async function getVariantsInfo(variantIds) {
    const now = Date.now();
    const gen = generation;
    const uniqueIds = [...new Set(variantIds)];
    const needsFetching = [];
    uniqueIds.forEach((id) => {
      const entry = cache.get(id);
      if (entry) {
        if (entry.expires >= now)
          return;
        cache.delete(id);
      }
      if (!inFlight.has(id))
        needsFetching.push(id);
    });
    if (needsFetching.length > 0) {
      const resolvers = /* @__PURE__ */ new Map();
      needsFetching.forEach((id) => {
        inFlight.set(id, new Promise((resolve) => resolvers.set(id, resolve)));
      });
      const remaining = [...needsFetching];
      while (remaining.length > 0) {
        const batch = remaining.splice(0, 20);
        const results = await Promise.allSettled(
          batch.map(async (id) => {
            const res = await fetch(`${Shopify.routes.root}variants/${id}?section_id=variant-info`);
            if (!res.ok)
              throw new Error(`variant-info ${id} responded ${res.status}`);
            const htmlString = await res.text();
            const doc = new DOMParser().parseFromString(htmlString, "text/html");
            return { id, value: JSON.parse(doc.body.textContent) };
          })
        );
        results.forEach((result, i) => {
          const id = batch[i];
          if (result.status === "fulfilled" && generation === gen) {
            cache.set(result.value.id, { value: result.value.value, expires: now + CACHE_TTL_MS });
          } else if (result.status === "rejected") {
            console.warn("getVariantsInfo: failed to fetch variant", result.reason?.message);
          }
          resolvers.get(id)();
          inFlight.delete(id);
        });
      }
    }
    const piggybackPromises = uniqueIds.map((id) => inFlight.get(id)).filter(Boolean);
    if (piggybackPromises.length > 0)
      await Promise.all(piggybackPromises);
    const list = {};
    uniqueIds.forEach((id) => {
      const entry = cache.get(id);
      if (entry)
        list[id] = entry.value;
    });
    return list;
  }

  // app/scripts/utils/getRegionData.js
  function normalizeString(str) {
    return str.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }
  function getRegionData() {
    if (theme.customer.isB2B) {
      const pcNumber = window.cart_attributes.preferred_location_id ? window.cart_attributes.preferred_location_id : theme.customer.company.address.pc_number;
      const foundShopLocation = theme.shopLocations.find((location2) => location2.pc_number == pcNumber);
      if (!foundShopLocation) {
        return null;
      }
      const foundRegion = theme.regionData.find(
        (region) => normalizeString(region.title) === normalizeString(foundShopLocation.region)
      );
      return foundRegion;
    }
    const regionSelector = document.querySelector("select-region");
    if (regionSelector?.currentRegion) {
      return regionSelector.currentRegion;
    }
    const defaultAddress = theme?.customer?.defaultAddress;
    if (defaultAddress?.province_code && Array.isArray(theme?.regionData)) {
      const selectedRegion = theme.regionData.find(
        (region) => Array.isArray(region.provinces) && region.provinces.includes(defaultAddress.province_code)
      );
      if (selectedRegion) {
        return selectedRegion;
      }
    }
    return null;
  }

  // app/scripts/utils/findPPLProduct.js
  function findPPLProduct(PPLProductList) {
    const selectedRegion = getRegionData();
    return PPLProductList.find((item) => item.CustomerID == selectedRegion.customer_id);
  }

  // app/scripts/utils/addQuantityAndUnitPrice.js
  function addQuantityAndUnitPrice(formData, price, quantity) {
    formData.append("properties[_quantity]", quantity);
    formData.delete("quantity");
    formData.append("properties[_unitPrice]", String(price));
  }

  // app/scripts/utils/distance.js
  var EARTH_RADIUS_KM = 6371;
  var degreesToRadians = (degrees) => degrees * Math.PI / 180;
  var haversineKm = (lat1, lng1, lat2, lng2) => {
    if (lat1 == null || lng1 == null || lat2 == null || lng2 == null || isNaN(lat1) || isNaN(lng1) || isNaN(lat2) || isNaN(lng2)) {
      return null;
    }
    const lat1Rad = degreesToRadians(Number(lat1));
    const lat2Rad = degreesToRadians(Number(lat2));
    const dLat = degreesToRadians(Number(lat2) - Number(lat1));
    const dLng = degreesToRadians(Number(lng2) - Number(lng1));
    const a = Math.sin(dLat / 2) ** 2 + Math.cos(lat1Rad) * Math.cos(lat2Rad) * Math.sin(dLng / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return EARTH_RADIUS_KM * c;
  };

  // app/scripts/utils/getPcNumbersForLocation.js
  function getPcNumbersForLocation(_location) {
    return theme.shopLocations.filter((location2) => !!location2.pc_number).filter((location2) => location2.region === _location.region).map((location2) => {
      const {
        address: { latitude, longitude }
      } = location2;
      const distanceKm = haversineKm(
        Number(latitude),
        Number(longitude),
        Number(_location.address.latitude),
        Number(_location.address.longitude)
      );
      return { ...location2, distanceKm };
    }).sort((a, b) => a.distanceKm - b.distanceKm).filter(({ distanceKm }) => distanceKm <= theme.settings.distanceMax).map((location2) => location2.pc_number);
  }

  // app/scripts/utils/calculateRegionInventoryTotal.js
  function calculateRegionInventoryTotal(WarehousesQuantities, location2, locationInventoryQty) {
    const start = location2.pc_number === window.gic_customer.WarehouseName ? locationInventoryQty : 0;
    const pcNumbers = getPcNumbersForLocation(location2);
    const newRegionInventories = WarehousesQuantities.filter((item) => pcNumbers.includes(item.WarehouseName));
    return newRegionInventories.reduce((sum, item) => sum + item.Quantity, start);
  }

  // app/scripts/utils/getPickupQuantity.js
  function getPickupQuantity(WarehousesQuantities, location2, locationInventoryQty) {
    if (location2.pc_number !== window.gic_customer.WarehouseName) {
      return WarehousesQuantities.find(({ WarehouseName }) => WarehouseName === location2.pc_number)?.Quantity || 0;
    }
    return locationInventoryQty;
  }

  // app/scripts/utils/getLocalizedRegionName.js
  var localizedRegionMap = {};
  var locationMap = theme?.shopLocations?.reduce((acc, location2) => {
    if (location2.id) {
      acc[location2.id] = location2;
    }
    return acc;
  }, {}) || {};
  if (Shopify.locale !== "en") {
    Object.assign(
      localizedRegionMap,
      theme?.regionData?.reduce((acc, region) => {
        const foundLocation = locationMap[region.location_id];
        if (foundLocation && foundLocation.region) {
          acc[region.title] = foundLocation.region;
        }
        return acc;
      }, {})
    );
  }
  function getLocalizedRegionName(regionName) {
    return localizedRegionMap[regionName] || regionName;
  }

  // app/scripts/utils/getEcoFee.js
  function getEcoFee(ecoFeeData, regionData, provinceCode) {
    if (!Array.isArray(ecoFeeData))
      return void 0;
    if (provinceCode) {
      const exactMatch = ecoFeeData.find(
        (ecoFee) => ecoFee.Province?.toLowerCase() === provinceCode.toLowerCase()
      );
      return exactMatch?.Fee;
    }
    const provinces = regionData?.provinces;
    if (!Array.isArray(provinces))
      return void 0;
    const foundEcoFee = ecoFeeData.find(
      (ecoFee) => provinces.some((province) => province.toLowerCase() === ecoFee.Province?.toLowerCase())
    );
    return foundEcoFee?.Fee;
  }

  // app/scripts/utils/getCustomerProvinceCode.js
  function getCustomerProvinceCode(activeRegion, preferredLocationId = window.cart_attributes?.preferred_location_id) {
    if (theme.customer?.isB2B) {
      const homePcNumber = theme.customer.company?.address?.pc_number;
      if (preferredLocationId && homePcNumber && String(preferredLocationId) !== String(homePcNumber)) {
        return activeRegion?.provinces?.[0] || null;
      }
      return window.gic_customer?.ShippingProvince || null;
    }
    return theme.customer?.defaultAddress?.province_code || null;
  }

  // app/scripts/utils/index.js
  window.theme = Object.assign(window.theme, {
    utils: {
      getEcoFee,
      getCustomerProvinceCode,
      getVariantsInfo,
      getRegionData,
      countDecimals,
      findPPLProduct,
      checkAndUpdateQuantity,
      addQuantityAndUnitPrice,
      getPcNumbersForLocation,
      calculateRegionInventoryTotal,
      getPickupQuantity,
      getLocalizedRegionName
    },
    addEvent,
    debounceTime,
    delay,
    resizeObserver,
    inViewPort,
    scroll,
    dispatchEvent,
    disableScroll,
    enableScroll,
    drawers: new DrawerManagement(),
    header: section,
    debounceEventDispatcher: debounceEvent_default,
    handleQueue,
    localStorage: localStorage2,
    sessionStorage
  });

  // app/scripts/components/lazyScript.js
  var customElementsName = "lazy-script";
  !window.customElements.get(customElementsName) && window.customElements.define(
    customElementsName,
    class extends HTMLElement {
      constructor() {
        super();
        if (!("IntersectionObserver" in window) && !("IntersectionObserverEntry" in window) && !("intersectionRatio" in window.IntersectionObserverEntry.prototype)) {
          this.inVisible();
          return;
        }
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.inVisible();
                observer.disconnect();
              }
            });
          },
          { rootMargin: "400px 0px 400px 0px" }
        );
        observer.observe(this);
      }
      inVisible() {
        setTimeout(() => {
          this.loadFiles();
          this.changeTag();
        }, 100);
      }
      loadFiles() {
        const { file: files } = this.dataset;
        if (!files)
          return;
        this.removeAttribute("data-file");
        files.split(",").forEach((file) => {
          if (file.includes(".js")) {
            const parts = file.split("/");
            const fileName = parts[parts.length - 1].split(".js")[0];
            if (document.querySelector(`script[data-uniq="${fileName}"]`))
              return;
            const script = document.createElement("script");
            script.setAttribute("data-uniq", fileName);
            script.src = file;
            document.head.insertAdjacentElement("beforeend", script);
          } else {
            const parts = file.split("/");
            const fileName = parts[parts.length - 1].split(".css")[0];
            if (document.querySelector(`link[data-uniq="${fileName}"]`))
              return;
            const stylesheet = document.createElement("link");
            stylesheet.href = file;
            stylesheet.rel = "stylesheet";
            stylesheet.type = "text/css";
            stylesheet.media = "all";
            stylesheet.setAttribute("data-uniq", fileName);
            document.head.insertAdjacentElement("beforeend", stylesheet);
          }
        });
      }
      changeTag() {
        const { tag = "div" } = this.dataset;
        if (!tag)
          return;
        const el = document.createElement(tag || "div");
        this.removeAttribute("data-tag");
        Array.from(this.attributes).forEach((attr, i) => {
          el.setAttribute(this.attributes[i].name, this.attributes[i].value);
        });
        Array.from(this.children)?.forEach((child) => {
          el.insertAdjacentElement("beforeend", child);
        });
        this.insertAdjacentElement("beforebegin", el);
        this.remove();
      }
    }
  );

  // app/scripts/utils/toggleClass.js
  var { addEvent: addEvent2 } = theme;
  addEvent2("click", ".jsToggleClass", (e) => {
    const el = e.target.closest(".jsToggleClass");
    const target = document.querySelectorAll(el.dataset.target || null);
    if (!target.length)
      return;
    let { className, classRemove, classRule, classEvent } = el.dataset;
    if (classEvent == "none") {
      e.preventDefault();
      e.stopPropagation();
    }
    target.forEach((i) => {
      switch (classRule) {
        case "add":
          i.classList.add(...className.split(","));
          break;
        case "remove":
          i.classList.remove(...className.split(","));
          break;
        default:
          className.split(",").forEach((c) => i.classList.toggle(c));
      }
      if (classRemove) {
        i.classList.remove(...classRemove.split(","));
      }
      i.className.includes("header-search") && document.querySelector("header predictive-search")?.focusSearch();
    });
  });

  // app/scripts/utils/togglePopup.js
  var { addEvent: addEvent3, loadTemplate } = theme;
  addEvent3("click", ".jsTogglePopup", (e) => {
    const el = e.target.closest(".jsTogglePopup");
    const { control: popupControlId } = el.dataset;
    let popup = document.querySelector(popupControlId);
    if (!popup)
      return;
    if (popupControlId == "#cartDrawer" && theme.settings.cartStyle == "drawer_desktop" && !window.matchMedia("(min-width: 750px)").matches || popupControlId == "#filterPopup") {
      return;
    }
    if (popupControlId == "#storeInventory" && el.classList.contains("header-pickup-locations")) {
      const popupInventory = popup?.querySelector(".popup-inventory");
      if (popupInventory) {
        popupInventory.classList.add("header-pickup-locations");
        popupInventory.classList.remove("pdp-locations");
      }
    } else if (popupControlId == "#storeInventory" && el.classList.contains("store-inventory-wrapper__footer")) {
      const popupInventory = popup?.querySelector(".popup-inventory");
      if (popupInventory) {
        popupInventory.classList.remove("header-pickup-locations");
        popupInventory.classList.add("pdp-locations");
        const productFormEl = el.closest("product-form");
        if (productFormEl) {
          const erpNumber = productFormEl.dataset.erpNumber;
          popupInventory.setAttribute("data-pdp-erp-number", erpNumber);
        }
      }
    }
    e.preventDefault();
    e.stopPropagation();
    el.classList.toggle("active");
    popup.isOpen ? popup.close() : popup.open();
  });
  addEvent3("click", ".jsPopupClose", (e) => {
    e.preventDefault();
    const el = e.target;
    const popup = el.closest(".popup-component");
    if (!popup)
      return;
    popup.close();
    document.querySelectorAll(`.jsTogglePopup[data-control="${popup.dataset.control}"]`)?.forEach((el2) => el2.classList.remove("active"));
  });

  // app/scripts/utils/loadTemplate.js
  var { addEvent: addEvent4 } = theme;
  addEvent4("click", ".jsTemplate", (e) => {
    const node = e.target.closest(".jsTemplate");
    const template = document.querySelector(node.dataset.template);
    if (!template)
      return;
    e.preventDefault();
    e.stopPropagation();
    template.tagName == "TEMPLATE" && Array.from(template.content.children)?.forEach((child) => {
      template.insertAdjacentElement("beforebegin", child);
    });
    if (template.tagName == "NOSCRIPT") {
      const div = document.createElement("div");
      div.innerHTML = template.innerHTML;
      template.insertAdjacentElement("beforebegin", div);
    }
    template.remove();
    node.classList.remove("jsTemplate");
    node.removeAttribute("data-template");
    setTimeout(() => {
      node.click();
    }, 300);
  });

  // app/scripts/utils/keyEvents.js
  document.addEventListener("keyup", (e) => {
    e.key == `Escape` && document.querySelectorAll("details[open]")?.forEach((item) => item.removeAttribute("open"));
  });

  // app/scripts/components/cartAction.js
  if (!customElements.get("cart-action")) {
    const {
      debounceEventDispatcher: debounceEventDispatcher3,
      scroll: scroll2,
      utils: { countDecimals: countDecimals4, addQuantityAndUnitPrice: addQuantityAndUnitPrice3 }
    } = theme;
    customElements.define(
      "cart-action",
      class extends HTMLElement {
        constructor() {
          super();
          this.added = false;
          this.quantity = this.querySelector("quantity-input");
          this.init();
        }
        init() {
          this.form = this.querySelector("form");
          this.form.addEventListener("submit", this.handleSubmit.bind(this));
          this.addEventListener("click", (event) => {
            if (event.target.matches("button[type='submit']")) {
              this.handleSubmit(event);
            }
          });
        }
        async handleSubmit(event) {
          event.preventDefault();
          event.stopPropagation();
          if (this.added) {
            return;
          }
          if (!this.form.checkValidity()) {
            const inputs = this.form.elements;
            let invalidInput = null;
            for (const input of inputs) {
              if (!input.validity.valid) {
                invalidInput = input;
                break;
              }
            }
            if (invalidInput) {
              scroll2(invalidInput);
              invalidInput.focus();
            }
            setTimeout(() => {
              this.form.reportValidity();
            }, 500);
            return;
          }
          this.classList.add("is-atc-loading");
          if (this.dataset.cutWire === "true") {
            const cutWireComponent = this.querySelector("cut-wire-component");
            if (cutWireComponent && !cutWireComponent.classList.contains("hidden")) {
              const cartData = cutWireComponent.getCartData();
              debounceEventDispatcher3.dispatch("cart:action", {
                type: "add",
                data: cartData,
                callback: () => {
                  this.handleAddedCart();
                  this.resetCutWireState(cutWireComponent);
                }
              });
              return;
            }
          }
          const formData = new FormData(this.form);
          const quantity = +this.quantity.value;
          if (countDecimals4(this.dataset.pricing) > 2) {
            addQuantityAndUnitPrice3(formData, this.dataset.pricing, quantity);
          } else {
            formData.delete("properties[quantity]");
            formData.append("quantity", quantity);
          }
          const dataToChange = await Cart.checkItemExists({
            id: this.form.id.value,
            quantity,
            erpNumber: this.dataset.erpnumber,
            price: this.dataset.pricing
          });
          if (!formData.get("properties[_my_part_number]")) {
            formData.delete("properties[_my_part_number]");
          }
          if (dataToChange) {
            await Cart.change({
              data: {
                ...dataToChange,
                sections: "drawer-cart-items,header-cart-popup",
                sections_url: `${theme.routes.searchUrl}?q=[variants.id:${this.form.id.value}]`
              },
              action: "add"
            });
          } else {
            formData.append("sections", "drawer-cart-items,header-cart-popup");
            formData.append("sections_url", `${theme.routes.searchUrl}?q=[variants.id:${this.form.id.value}]`);
            await Cart.add(formData);
          }
          this.handleAddedCart();
        }
        handleAddedCart() {
          this.classList.remove("is-atc-loading");
        }
        resetCutWireState(cutWireComponent) {
          if (cutWireComponent && cutWireComponent.reset) {
            cutWireComponent.reset();
          }
          const cutWireButton = this.querySelector(".jsCutWire");
          if (cutWireButton) {
            cutWireButton.classList.remove("hidden");
          }
        }
        updateQuantityStep(step) {
          if (!this.quantity)
            return;
          this.quantity.updateStep(step);
          if (step > 1) {
            const messageElm = this.querySelector(".js-sold-multiples-message");
            if (messageElm) {
              messageElm.textContent = messageElm.dataset.message.replace("{{ sold_multiples }}", step);
            }
          } else {
          }
        }
      }
    );
  }

  // app/scripts/components/cartRemove.js
  var customElementsName2 = "cart-remove-button";
  !window.customElements.get(customElementsName2) && window.customElements.define(
    customElementsName2,
    class extends HTMLElement {
      constructor() {
        super();
        this.addEventListener("click", (e) => {
          const { target } = e;
          if (!target.closest("a"))
            return;
          const link = target.closest("a");
          e.preventDefault();
          this.closest("cart-component").dispatchEvent(
            new CustomEvent("change", {
              bubbles: true,
              detail: {
                customElement: link
              }
            })
          );
        });
      }
    }
  );

  // app/scripts/utils/cartPDP.js
  var { handleQueue: handleQueue2, debounceEventDispatcher, debounceTime: debounceTime2 } = theme;
  var Cart2 = class {
    constructor() {
      this.sections = ["cart-section", "cart-live-region-text", "drawer-cart-items", "header-cart-popup"];
      this.abortController = new AbortController();
      this.createEvents();
    }
    headers(formData) {
      if (formData instanceof FormData)
        return { "X-Requested-With": "XMLHttpRequest" };
      return { "Content-Type": "application/json" };
    }
    createEvents() {
      this._handleCartAction = (event) => {
        const { type, data, callback } = event.detail;
        this.handleCartAction({ type, data, callback });
      };
      window.addEventListener("cart:action", this._handleCartAction);
    }
    async handleCartAction({ type, data, callback }) {
      switch (type) {
        case "add":
          this.handleCartAdd(data, callback);
          break;
        case "change":
          this.handleCartChange(data, callback);
          break;
        case "remove":
          this.handleCartRemove(data);
          break;
        case "update":
          this.handleCartUpdate();
          break;
        default:
          break;
      }
    }
    async handleCartAdd(data, callback = null) {
      let releaseCartWrite;
      try {
        let body = data;
        let requestBody;
        if (body instanceof FormData) {
          body.append("sections", this.sections.join(","));
          body.append("sections_url", `${theme.routes.searchUrl}?q=[variants.id:${body.get("id")}]`);
          requestBody = body;
        } else {
          const requestData = { ...body, sections: this.sections.join(",") };
          requestBody = JSON.stringify(requestData);
        }
        releaseCartWrite = window.Cart?.trackCartWrite?.();
        const response = await fetch(`${theme.routes.cartUrl}/add.js`, {
          method: "POST",
          headers: this.headers(body),
          body: requestBody
        });
        if (!response.ok) {
          const error = await response.json();
          throw error;
        }
        const results = await response.json();
        if (theme.customer.isB2B) {
          theme.header.cart.update(results).open();
        } else {
          theme.drawers.cart.update(results).open(results.key);
        }
        if (results.sections) {
          await this.handleSections(results.sections);
        }
      } catch (error) {
        console.error(error);
        return null;
      } finally {
        releaseCartWrite?.();
        callback?.();
        const popupQuickshop = document.querySelector("popup-component#quickshop");
        if (popupQuickshop) {
          popupQuickshop.close();
        }
      }
    }
    handleCartChange(data, callback = null) {
      handleQueue2(async () => {
        let body = data;
        if (body instanceof FormData) {
          body.append("sections", this.sections.join(","));
        } else {
          body = {
            ...body,
            sections: this.sections.join(",")
          };
        }
        const releaseCartWrite = window.Cart?.trackCartWrite?.();
        try {
          const response = await fetch(`${theme.routes.cartUrl}/update.js`, {
            method: "POST",
            headers: this.headers(body),
            body: JSON.stringify(body)
          });
          if (!response.ok) {
            this.handleError(await response.json());
            callback?.();
            return null;
          }
          const results = await response.json();
          if (results.sections) {
            await this.handleSections(results.sections);
          }
        } finally {
          releaseCartWrite?.();
        }
        callback?.();
      });
    }
    async handleCartRemove(data) {
      this.removeQueue = this.removeQueue || /* @__PURE__ */ new Set();
      this.removeQueue.add(data);
      this.removeTimeout && clearTimeout(this.removeTimeout);
      this.removeTimeout = setTimeout(() => {
        const updates = [...this.removeQueue].reduce((acc, item) => {
          return { ...acc, ...item.updates };
        }, {});
        this.handleCartAction({
          type: "change",
          data: { updates },
          callback: () => {
            this.removeQueue = null;
          }
        });
      }, 300);
    }
    async handleCartUpdate() {
      try {
        const response = await fetch(`${theme.routes.cartUrl}?sections=${this.sections.join(",")}`, {
          signal: this.abortController.signal
        });
        const results = await response.json();
        await this.handleSections(results);
      } catch (error) {
        if (error.name === "AbortError") {
          console.warn("Cart update was aborted");
          return;
        }
        this.handleError(error);
      }
    }
    handleError(error, callback = null) {
      console.error(error);
    }
    async handleSections(sections) {
      debounceEventDispatcher.dispatch("cart:update", { sections });
      await window.Cart?.syncCoveoCart?.(null, { forceFetch: true });
    }
    updateCartCounter(html) {
      const number = html.split("<!-- split -->")[1];
      document.querySelectorAll(".jsCartCount").forEach((item) => {
        item.setAttribute("data-count", number);
      });
    }
    notify(msg, callback = null) {
      handleQueue2(async () => {
        const searchParams = new URLSearchParams();
        searchParams.set("q", msg);
        searchParams.set("section_id", "cart-noti");
        let response = await fetch(`${theme.routes.searchUrl}?${searchParams.toString()}`);
        response = await response.text();
        let div = document.createElement("div");
        div.innerHTML = response;
        callback?.();
      });
    }
  };
  new Cart2();

  // app/scripts/modules/coveo-cart-delta.js
  var resolveCoveoCartDelta = ({ prevQuantity, nextQuantity, itemsAdded, itemsRemoved }) => {
    const delta = nextQuantity - prevQuantity;
    if (!Number.isFinite(delta) || delta === 0)
      return null;
    if (delta > 0)
      return itemsAdded ? null : { action: "add", quantity: delta };
    return itemsRemoved ? null : { action: "remove", quantity: -delta };
  };

  // app/scripts/modules/cart.js
  var LIMITED_BUYER = "limited buyer";
  var CART_ADD_BATCH_SIZE = 10;
  var BATCH_ADD_DELAY_MS = 500;
  var toVariantGid = (id) => `gid://shopify/ProductVariant/${id}`;
  var coveoCartKey = (item) => `${item.productId},${item.name},${item.price}`;
  var toCoveoCartItem = (item) => {
    const realQty = Number(item.properties?._quantity ?? item.quantity);
    const lineTotal = item.final_line_price ?? item.final_price * item.quantity;
    const unitPrice = realQty > 0 ? lineTotal / realQty : lineTotal;
    return {
      productId: toVariantGid(item.variant_id),
      name: item.title,
      price: unitPrice,
      quantity: realQty
    };
  };
  var dispatchCoveoSetItems = (engine, items) => {
    const setItems = window.coveoheadless?.loadCartActions?.(engine)?.setItems;
    if (!setItems) {
      console.warn("[Cart] Coveo setItems unavailable \u2014 engine state not synced");
      return;
    }
    engine.dispatch(setItems(items));
  };
  var dispatchCoveoCartAction = (payload) => {
    const engine = (window.CoveoEngines || []).find((e) => e?.cart);
    const emitCartActionEvent = engine && window.coveoheadless?.loadCartActions?.(engine)?.emitCartActionEvent;
    if (!emitCartActionEvent) {
      console.warn("[Cart] Coveo emitCartActionEvent unavailable \u2014 cart action not tracked");
      return;
    }
    engine.dispatch(emitCartActionEvent(payload));
  };
  var isCoveoCartUnchanged = (currentItems, nextByKey) => {
    if (currentItems.length !== nextByKey.size)
      return false;
    for (const c of currentItems) {
      const next = nextByKey.get(coveoCartKey(c));
      if (!next || next.quantity !== c.quantity)
        return false;
    }
    return true;
  };
  var { getVariantsInfo: getVariantsInfo2, countDecimals: countDecimals2, findPPLProduct: findPPLProduct2, getRegionData: getRegionData2 } = theme.utils;
  var { debounceEventDispatcher: debounceEventDispatcher2, delay: delay2 } = theme;
  var PROVINCE_REGION_MAP = {
    "British Columbia": "BC",
    Quebec: "QC",
    Alberta: "AB",
    Ontario: "ON",
    Saskatchewan: "SK",
    "New Brunswick": "NB",
    "Prince Edward Island": "PE",
    Manitoba: "MB",
    "Newfoundland and Labrador": "NL",
    "Nova Scotia": "NS",
    Yukon: "YT",
    "Northwest Territories": "NT",
    Nunavut: "NU"
  };
  var Cart3 = class {
    constructor() {
      this.customerRole = null;
      this._value = null;
      this._pendingGet = null;
      this._cartVersion = 0;
      this._pendingCartWrites = 0;
      window.addEventListener("focus", () => this.syncCoveoCart(null, { deferOnPendingWrites: true }));
    }
    trackCartWrite() {
      this._pendingCartWrites += 1;
      return () => {
        this._pendingCartWrites -= 1;
      };
    }
    async withCartWrite(callback) {
      const releaseCartWrite = this.trackCartWrite();
      try {
        return await callback();
      } finally {
        releaseCartWrite();
      }
    }
    async syncCoveoCart(cartData = null, { deferOnPendingWrites = false, forceFetch = false } = {}) {
      if (deferOnPendingWrites && this._pendingCartWrites > 0)
        return;
      const cartVersion = this._cartVersion;
      let cart = cartData;
      if (!cart) {
        try {
          cart = await this.get({ force: forceFetch });
        } catch (err) {
          console.error("Failed to fetch cart for Coveo sync", err);
          return;
        }
        if (deferOnPendingWrites && this._pendingCartWrites > 0)
          return;
        if (cartVersion !== this._cartVersion)
          return;
      }
      const engines = window.CoveoEngines || [];
      if (!engines.length)
        return;
      const nextByKey = /* @__PURE__ */ new Map();
      for (const item of cart.items || []) {
        const next = toCoveoCartItem(item);
        const key = coveoCartKey(next);
        const existing = nextByKey.get(key);
        if (existing) {
          existing.quantity += next.quantity;
        } else {
          nextByKey.set(key, next);
        }
      }
      let nextItems = null;
      for (const engine of engines) {
        const coveoCart = engine?.cart;
        if (!coveoCart)
          continue;
        const currentItems = coveoCart.state?.items || [];
        if (isCoveoCartUnchanged(currentItems, nextByKey))
          continue;
        nextItems ??= [...nextByKey.values()];
        dispatchCoveoSetItems(engine, nextItems);
      }
    }
    setHeaders(data) {
      return data instanceof FormData ? {} : { "Content-Type": "application/json" };
    }
    async value() {
      if (!this._value) {
        return this.get();
      }
      return this._value;
    }
    async get({ force = false } = {}) {
      if (this._pendingGet && !force) {
        return this._pendingGet;
      }
      const cartVersion = this._cartVersion;
      const pendingGet = fetch(`${theme.routes.cartUrl}.js`).then((res) => res.json());
      this._pendingGet = pendingGet;
      try {
        const cart = await pendingGet;
        if (this._pendingGet === pendingGet && cartVersion === this._cartVersion)
          this._value = cart;
        return cart;
      } finally {
        if (this._pendingGet === pendingGet)
          this._pendingGet = null;
      }
    }
    async add(data, { skipCoveoSync = false } = {}) {
      return this.withCartWrite(async () => {
        const res = await fetch(`${theme.routes.cartUrl}/add.js`, {
          method: "POST",
          body: data instanceof FormData ? data : JSON.stringify(data),
          headers: this.setHeaders(data)
        });
        if (!res.ok) {
          const text = await res.text();
          throw new Error(`Cart add failed (${res.status}): ${text}`);
        }
        const response = await res.json();
        this._cartVersion += 1;
        if (!skipCoveoSync)
          await this.syncCoveoCart(null, { forceFetch: true });
        this.updateCartLayout(response, "add");
        return response;
      });
    }
    buildItemProperties(pricing, ecoFee) {
      return theme.customer.isB2B ? {
        ...ecoFee ? { _ecofee: ecoFee } : {},
        _b2b_price: String(pricing.Pricing),
        _b2b_key: pricing.key,
        _source: pricing.Source
      } : {
        ...ecoFee ? { _ecofee: ecoFee } : {},
        _source: pricing?.Source
      };
    }
    async batchAdd(items, sections) {
      return this.withCartWrite(async () => {
        let lastResponse;
        for (let i = 0; i < items.length; i += CART_ADD_BATCH_SIZE) {
          const batch = items.slice(i, i + CART_ADD_BATCH_SIZE);
          const isLast = i + CART_ADD_BATCH_SIZE >= items.length;
          const data = { items: batch };
          if (isLast && sections)
            Object.assign(data, sections);
          if (i > 0)
            await delay2(BATCH_ADD_DELAY_MS);
          lastResponse = await this.add(data, { skipCoveoSync: !isLast });
        }
        return lastResponse;
      });
    }
    async batchChange(items, sections) {
      return this.withCartWrite(async () => {
        const cart = await this.value();
        let lastResponse;
        for (let i = 0; i < items.length; i++) {
          if (i > 0)
            await delay2(BATCH_ADD_DELAY_MS);
          const isLast = i === items.length - 1;
          const lineKey = String(items[i].id);
          const lineIndex = cart.items.findIndex((li) => li.key === lineKey);
          if (lineIndex < 0) {
            throw new Error(`[Cart] Line ${lineKey} not found in cart snapshot`);
          }
          const { id, ...rest } = items[i];
          const item = { ...rest, line: lineIndex + 1 };
          const data = isLast && sections ? { ...item, ...sections } : item;
          lastResponse = await this.change({ data, updateLayout: isLast, action: "add" });
        }
        return lastResponse;
      });
    }
    async change({ data, updateLayout = true, action = "change" }) {
      try {
        const dataToChange = { ...data };
        if (data.variantId) {
          const foundLineItem = await this.findLineItem(data.variantId);
          if (!foundLineItem)
            throw new Error("Line item is not found");
          dataToChange.id = foundLineItem.key;
          delete dataToChange.variantId;
        }
        return this.withCartWrite(async () => {
          const prevCart = this._value;
          const res = await fetch(`${theme.routes.cartUrl}/change.js`, {
            method: "POST",
            body: JSON.stringify(dataToChange),
            headers: this.setHeaders(dataToChange)
          });
          const response = await res.json();
          if (!res.ok)
            throw response;
          this._cartVersion += 1;
          this.emitCoveoCartDelta(dataToChange, prevCart, response);
          if (updateLayout) {
            this._value = response;
            await this.syncCoveoCart(response);
            this.updateCartLayout(response, action);
          }
          return response;
        });
      } catch (error) {
        throw error;
      }
    }
    // Emits the theme-side `ec.cartAction` for a change.js line-qty change; resolveCoveoCartDelta decides
    // whether to emit (skips when the Web Pixel already fired) and toCoveoCartItem yields the real quantity.
    emitCoveoCartDelta(requestData, prevCart, nextCart) {
      try {
        const prevLine = requestData.line ? prevCart?.items?.[requestData.line - 1] : prevCart?.items?.find(
          (item) => item.key === String(requestData.id) || String(item.variant_id) === String(requestData.id)
        );
        if (!prevLine)
          return;
        const nextLine = nextCart.items?.find((item) => item.key === prevLine.key) ?? nextCart.items?.find(
          (item) => item.variant_id === prevLine.variant_id && this.isPropertiesEqual(item.properties, requestData.properties)
        );
        const trackedLine = nextLine ?? prevLine;
        const next = toCoveoCartItem(trackedLine);
        const decision = resolveCoveoCartDelta({
          prevQuantity: toCoveoCartItem(prevLine).quantity,
          nextQuantity: nextLine ? next.quantity : 0,
          itemsAdded: !!nextCart.items_added?.length,
          itemsRemoved: !!nextCart.items_removed?.length
        });
        if (!decision)
          return;
        const price = Number(trackedLine.properties?._unitPrice ?? next.price / 100);
        dispatchCoveoCartAction({
          ...decision,
          product: { productId: next.productId, name: next.name, price }
        });
      } catch (error) {
        console.error("[Cart] Failed to emit Coveo cart delta", error);
      }
    }
    async update(data) {
      try {
        return this.withCartWrite(async () => {
          const res = await fetch(`${theme.routes.cartUrl}/update.js`, {
            method: "POST",
            body: data instanceof FormData ? data : JSON.stringify(data),
            headers: this.setHeaders(data)
          });
          const response = await res.json();
          if (!res.ok)
            throw response;
          this._cartVersion += 1;
          this._value = response;
          await this.syncCoveoCart(response);
          this.updateCartLayout(response);
          return response;
        });
      } catch (error) {
        throw error;
      }
    }
    /**
     * @param {Object} data
     * @returns {Promise<Object>}
     */
    async updateAttributes(data, updateCartComponent = true) {
      const cartComponent = document.querySelector("cart-component");
      try {
        const dataToSend = { attributes: data };
        cartComponent?.setState?.("loading");
        if (theme.requestType === "cart") {
          dataToSend.sections = cartComponent.id;
        } else if (!theme.customer.isB2B) {
          dataToSend.sections = "drawer-cart-items";
        }
        const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
          method: "POST",
          body: JSON.stringify(dataToSend),
          headers: this.setHeaders(dataToSend)
        }).then((res) => res.json());
        this._value = response;
        this.updateCartLayout(response);
        updateCartComponent && cartComponent?.updateLayout?.(response);
        return response;
      } catch (error) {
        throw error;
      } finally {
        cartComponent?.setState?.("reset");
      }
    }
    updateCartLayout(data, action) {
      if (!("sections" in data))
        return;
      theme.header.cart.update(data);
      if (theme.customer.isB2B) {
        !location.href.includes("/cart") && action === "add" && theme.header.cart.open();
      } else {
        theme.drawers?.cart?.update(data);
        action === "add" && theme.drawers?.cart?.open(data.key);
      }
    }
    async clear(data) {
      try {
        return this.withCartWrite(async () => {
          const res = await fetch(`${theme.routes.cartUrl}/clear.js`, {
            method: "POST",
            body: JSON.stringify(data),
            headers: this.setHeaders(data)
          });
          const response = await res.json();
          if (!res.ok)
            throw response;
          this._cartVersion += 1;
          this._value = response;
          let primaryHandled = false;
          for (const engine of window.CoveoEngines || []) {
            if (!engine?.cart)
              continue;
            if (!primaryHandled) {
              primaryHandled = true;
              engine.cart.empty?.();
            } else {
              dispatchCoveoSetItems(engine, []);
            }
          }
          this.updateCartLayout(response);
          return response;
        });
      } catch (error) {
        throw error;
      }
    }
    addDefaultSections(variantIds) {
      return {
        sections: "drawer-cart-items,header-cart-popup",
        sections_url: `${theme.routes.searchUrl}?q=${variantIds.map((id) => `[variants.id:${id}]`).join(" OR ")}`
      };
    }
    async hasCheckoutPermission() {
      try {
        if (!theme.customer.isB2B)
          return true;
        if (this.customerRole) {
          return this.customerRole.toLowerCase() !== LIMITED_BUYER;
        }
        const response = await fetch(`${Shopify.routes.root}apps/gic-integrations/api/get-role/app-proxied`).then(
          (res) => res.json()
        );
        if (!response.customRole)
          return true;
        this.customerRole = response.customRole;
        return response.customRole.toLowerCase() !== LIMITED_BUYER;
      } catch (error) {
        throw error;
      }
    }
    async checkItemExists({ id, quantity, erpNumber, price, sumLineItemCount = true, fresh = true }) {
      return theme.customer.isB2B ? this.b2bCheckItemExists({ id, quantity, erpNumber, sumLineItemCount, fresh }) : this.nonB2BCheckItemExists({ id, price, quantity, sumLineItemCount });
    }
    async b2bCheckItemExists({ id, quantity, erpNumber, sumLineItemCount = true, fresh = true }) {
      try {
        if (fresh)
          await this.get();
        const foundLineItem = await this.findLineItem(id);
        if (!foundLineItem)
          return null;
        const { properties } = foundLineItem;
        const lineItemQuantity = properties?._quantity || foundLineItem.quantity;
        const totalQuantity = sumLineItemCount ? Number(lineItemQuantity) + Number(quantity) : Number(quantity);
        const pricing = PriceInventory.findPricingByQtyBreak(erpNumber, totalQuantity);
        if (!pricing) {
          const error = new Error(`[Cart] Pricing unavailable for erpNumber ${erpNumber}`);
          error.pricingUnavailable = true;
          throw error;
        }
        const data = {
          id: foundLineItem.key,
          properties: {
            ...foundLineItem.properties,
            _b2b_price: String(pricing.Pricing),
            _unitPrice: String(pricing.Pricing),
            _b2b_key: pricing.key,
            _source: pricing.Source
          }
        };
        if (countDecimals2(pricing.Pricing) > 2) {
          data.properties._quantity = String(totalQuantity);
          data.quantity = 1;
        } else {
          data.quantity = totalQuantity;
          delete data.properties._quantity;
        }
        return data;
      } catch (error) {
        throw error;
      }
    }
    async nonB2BCheckItemExists({ id, price, quantity, sumLineItemCount = true }) {
      try {
        const foundLineItem = await this.findLineItem(id);
        if (!foundLineItem) {
          return null;
        }
        const { properties } = foundLineItem;
        const lineItemQuantity = properties?._quantity || foundLineItem.quantity;
        const totalQuantity = sumLineItemCount ? Number(lineItemQuantity) + Number(quantity) : Number(quantity);
        const data = {
          id: foundLineItem.key,
          properties: {
            ...Object.fromEntries(Object.entries(properties).filter(([key]) => !key.startsWith("_b2b_"))),
            _unitPrice: String(price)
          }
        };
        if (countDecimals2(price || 0) > 2) {
          data.properties._quantity = String(totalQuantity);
          data.properties._unitPrice = String(price);
          data.quantity = 1;
        } else {
          data.quantity = totalQuantity;
          delete data.properties._quantity;
        }
        return data;
      } catch (error) {
        throw error;
      }
    }
    async checkLineItemsProperties() {
      const cartPage = document.querySelector(".section-main-cart cart-component");
      if (cartPage) {
        await customElements.whenDefined("cart-component");
      }
      try {
        cartPage?.setState("loading");
        const cartValue = await this.value();
        const variantIds = cartValue.items.map((item) => item.variant_id);
        const variantsInfo = await getVariantsInfo2(variantIds);
        const sections = location.href.includes("/cart") ? [cartPage?.dataset?.sectionIds?.split(",")?.[0], "header-cart-popup"].filter(Boolean).join(",") : "drawer-cart-items,header-cart-popup";
        await PriceInventory.fetchForVariants(variantsInfo);
        const itemsToChange = [];
        for (const lineItem of cartValue.items) {
          const { properties, key } = lineItem;
          const quantity = Number(properties?._quantity || lineItem.quantity);
          const variantInfo = variantsInfo[lineItem.variant_id];
          const newQuantity = variantInfo?.PCProduct?.MinimumOrderQty > quantity ? variantInfo.PCProduct.MinimumOrderQty : quantity;
          const PPLPrice = variantInfo?.pplPricing?.Pricing?.[0]?.Pricing;
          let dataToChange;
          try {
            dataToChange = await this.checkItemExists({
              id: key,
              quantity: newQuantity,
              erpNumber: variantInfo.erpNumber,
              sumLineItemCount: false,
              price: PPLPrice,
              fresh: false
            });
          } catch (error) {
            if (error.pricingUnavailable)
              continue;
            throw error;
          }
          if (!dataToChange)
            continue;
          if (dataToChange.properties._ecofee !== String(variantInfo.ecoFee)) {
            variantInfo.ecoFee > 0 ? dataToChange.properties._ecofee = String(variantInfo.ecoFee) : delete dataToChange.properties._ecofee;
          }
          if (Number(dataToChange.properties?._quantity || dataToChange.quantity) === quantity && this.isPropertiesEqual(dataToChange.properties, properties)) {
            continue;
          }
          itemsToChange.push(dataToChange);
        }
        let lastResponse;
        for (let i = 0; i < itemsToChange.length; i++) {
          const isLast = i === itemsToChange.length - 1;
          lastResponse = await this.change({
            data: {
              ...itemsToChange[i],
              ...isLast ? { sections } : {}
            },
            updateLayout: isLast
          });
        }
        if (lastResponse) {
          cartPage?.updateLayout(lastResponse);
        }
      } catch (error) {
        throw error;
      } finally {
        cartPage?.setState("reset");
      }
    }
    async checkB2BAttributes() {
      try {
        const attributesToUpdate = {};
        const isCompanyLocationChanged = String(theme.customer.company.id) !== cart_attributes.company_id || String(window.gic_customer.WarehouseName) !== cart_attributes.company_location_id;
        const foundLocation = theme.shopLocations.find(
          (location2) => location2.pc_number == window.gic_customer.WarehouseName
        );
        if (!("preferred_location" in window.cart_attributes) || isCompanyLocationChanged) {
          foundLocation && Object.assign(attributesToUpdate, this.generatorPreferredLocationAttributes("delivery", foundLocation));
        }
        ["Region", "ship_to_id", "ship_from_location_id", "ship_from_location_name"].forEach((attribute) => {
          if (attribute in window.cart_attributes) {
            attributesToUpdate[attribute] = "";
          }
        });
        if (Object.keys(attributesToUpdate).length > 0) {
          await this.updateAttributes(attributesToUpdate);
          window.dispatchEvent(
            new CustomEvent("deliveryMethod:change", {
              detail: {
                deliveryMethod: attributesToUpdate.delivery_method,
                preferredLocation: foundLocation,
                updateHeader: true,
                updateAttributes: false
              }
            })
          );
        }
      } catch (error) {
        throw error;
      }
    }
    async checkNonB2BAttributes() {
      try {
        const attributesToUpdate = {};
        const { attributes } = await this.value();
        const { region_province_code = "", Region: Region2 = null } = attributes;
        const regionObject = JSON.parse(Region2);
        [
          "delivery_method",
          "preferred_location",
          "preferred_location_id",
          "company_id",
          "company_location_id",
          "ship_to_id",
          "ship_from_location_id",
          "ship_from_location_name"
        ].forEach((attribute) => {
          if (attribute in attributes) {
            attributesToUpdate[attribute] = "";
          }
        });
        if (theme.customer.defaultAddress) {
          const foundRegion = theme.regionData.find(
            (region) => Array.isArray(region.provinces) && region.provinces.includes(theme.customer.defaultAddress.province_code)
          );
          if (!region_province_code || !foundRegion.provinces.includes(region_province_code)) {
            Object.assign(attributesToUpdate, this.generatorRegionAttributes(foundRegion));
          }
        } else if ("Region" in attributes) {
          if (!regionObject.provinces.includes(region_province_code)) {
            attributesToUpdate.region_province_code = regionObject.provinces[0];
          }
        } else if (region_province_code) {
          const foundRegion = theme.regionData.find((region) => region.provinces.includes(region_province_code));
          foundRegion && Object.assign(attributesToUpdate, { ...this.generatorRegionAttributes(foundRegion), region_province_code });
        }
        Object.keys(attributesToUpdate).forEach((key) => {
          if (attributesToUpdate[key] === attributes[key]) {
            delete attributesToUpdate[key];
          }
        });
        if (Object.keys(attributesToUpdate).length > 0) {
          await this.updateAttributes(attributesToUpdate);
          attributesToUpdate.region_province_code && window.dispatchEvent(
            new CustomEvent("regionUpdated", {
              detail: {
                regionProvinceCode: attributesToUpdate.region_province_code
              }
            })
          );
        }
      } catch (error) {
        throw error;
      }
    }
    async updatePreferredLocation(deliveryMethod = "pickup", preferredLocation) {
      try {
        const attributesToUpdate = this.generatorPreferredLocationAttributes(deliveryMethod, preferredLocation);
        await this.updateAttributes(attributesToUpdate, false);
        this.checkLineItemsProperties();
      } catch (error) {
        throw error;
      }
    }
    generatorPreferredLocationAttributes(deliveryMethod = "pickup", preferredLocation) {
      const provinceCode = PROVINCE_REGION_MAP[preferredLocation.address.province];
      return {
        delivery_method: deliveryMethod,
        preferred_location: JSON.stringify(preferredLocation),
        preferred_location_id: preferredLocation.pc_number,
        company_id: String(theme.customer.company.id),
        company_location_id: String(window.gic_customer.WarehouseName),
        region_province_code: provinceCode ?? ""
      };
    }
    generatorRegionAttributes(regionData) {
      return {
        Region: JSON.stringify(regionData),
        region_title: "",
        // TODO: remove this attribute after all regions are updated
        region_province_code: regionData.provinces[0] ?? ""
      };
    }
    async findLineItem(key) {
      const cartValue = await this.value();
      return cartValue.items.find((item) => item.key == key || item.variant_id == key);
    }
    isPropertiesEqual(a, b) {
      if (a == b)
        return true;
      if (typeof a !== "object" || typeof b !== "object" || a == null || b == null)
        return false;
      const keysA = Object.keys(a);
      const keysB = Object.keys(b);
      if (keysA.length !== keysB.length)
        return false;
      for (const key of keysA) {
        if (!keysB.includes(key) || !this.isPropertiesEqual(a[key], b[key]))
          return false;
      }
      return true;
    }
    async updateRegionAttributes(regionData) {
      try {
        await this.updateAttributes(this.generatorRegionAttributes(regionData), false);
        this.checkLineItemsProperties();
      } catch (error) {
        throw error;
      }
    }
  };
  window.Cart = new Cart3();

  // app/scripts/modules/prices-inventory.js
  var {
    utils: { calculateRegionInventoryTotal: calculateRegionInventoryTotal2, getPickupQuantity: getPickupQuantity2 }
  } = theme;
  var PriceInventory2 = class {
    constructor() {
      this.storage = Object.assign(theme.localStorage("prices-inventory-cache", []), storageExtension);
      this.selectedLocation = theme.preferredLocation;
      this.init();
    }
    init() {
      window.addEventListener(
        "preferredLocation:change",
        ({ detail: { preferredLocation } }) => this.selectedLocation = preferredLocation
      );
    }
    getERPNumbers() {
      const erpNumbers = document.querySelectorAll("[data-erp-number]:not(.erp-processed)");
      const uniqueErpNumbers = [
        ...new Set(
          Array.from(erpNumbers).map((el) => {
            if (!el.classList.contains("pdp-product-form")) {
              el.classList.add("erp-processed");
            }
            return el.getAttribute("data-erp-number");
          }).filter(Boolean)
        )
      ];
      return uniqueErpNumbers;
    }
    /** Fetch pricing for the given variants (object map or array). B2B only — no-op otherwise. Does not touch the DOM, unlike {@link fetchLivePriceInventory}. */
    async fetchForVariants(variants) {
      if (!theme.customer.isB2B || !window.gic_customer)
        return;
      const erpNumbers = Object.values(variants).map((item) => item.erpNumber);
      if (erpNumbers.length)
        await this.fetch(erpNumbers);
    }
    async fetch(erpNumbers) {
      try {
        const url = `${Shopify.routes.root}apps/gic-live/api/jitterbit/price-inventory`;
        const { WarehouseName, ShippingProvince = "BC" } = window.gic_customer;
        const cachedPriceInventory = [];
        const erpNumbersToFetch = [...new Set(erpNumbers)].filter(Boolean).map((erpNumber) => {
          const erpData = this.storage.find(erpNumber);
          if (erpData) {
            cachedPriceInventory.push(erpData);
            return null;
          }
          return erpNumber;
        }).filter(Boolean);
        const params = {
          WarehouseName,
          ShippingProvince,
          Products: erpNumbersToFetch?.map((erpNumber) => ({ ErpNumber: erpNumber }))
        };
        const fetchedData = await (async () => {
          try {
            if (erpNumbersToFetch.length === 0) {
              return [];
            }
            const response = await fetch(url, {
              method: "POST",
              body: JSON.stringify(params),
              headers: {
                "Content-type": "application/json; charset=UTF-8"
              }
            });
            if (!response.ok) {
              throw new Error(`API responded with status ${response.status}`);
            }
            const data = await response.json();
            if (!Array.isArray(data)) {
              throw new Error("API response is not an array");
            }
            this.storage.save(data);
            return data;
          } catch (error) {
            console.error("Failed to fetch live price/inventory:", error);
            return [];
          }
        })();
        return [...cachedPriceInventory, ...fetchedData];
      } catch (error) {
        throw error;
      }
    }
    async fetchLivePriceInventory() {
      if (!theme.customer.isB2B)
        return;
      if (!window.gic_customer) {
        throw new Error("Customer Data not found");
      }
      const erpNumbers = this.getERPNumbers();
      try {
        if (!erpNumbers || erpNumbers.length === 0) {
          console.warn("ERP Numbers not found");
          return;
        }
        const fetchedPriceInventory = await this.fetch(erpNumbers);
        this.updateProductPriceInventory(fetchedPriceInventory, erpNumbers);
      } catch (error) {
        console.error("Failed to fetch live price/inventory:", error);
        this.updateProductPriceInventory([], erpNumbers);
      }
    }
    updateProductPriceInventory(dataUpdated, erpNumbers) {
      for (const erpNumber of erpNumbers) {
        const productCards = document.querySelectorAll(`[data-erp-number="${erpNumber}"]`);
        productCards.forEach((productCard) => {
          const erpNumber2 = productCard.getAttribute("data-erp-number");
          const { data: foundPriceInventory, key } = dataUpdated.find(({ data }) => data.ErpNumber === erpNumber2) || {};
          if (productCard.getAttribute("data-is-pdp") === "true") {
            productCard?.updateB2BLayout?.(foundPriceInventory, key);
            return;
          }
          if (!(foundPriceInventory && foundPriceInventory.Pricing.length > 0)) {
            productCard.setState("price-unavailable");
            productCard.setState("fetched-price");
            return;
          }
          productCard.updateB2BLayout(foundPriceInventory, this.selectedLocation);
        });
      }
    }
    findPricingByQtyBreak(erpNumber, quantity) {
      const priceInventory = this.storage.find(erpNumber);
      if (!priceInventory)
        return null;
      const sortedDPricing = priceInventory.data.Pricing.sort((a, b) => a.QtyBreak - b.QtyBreak);
      let selected = sortedDPricing[0];
      for (const item of sortedDPricing) {
        if (Number(quantity) >= Number(item.QtyBreak)) {
          selected = item;
        } else {
          break;
        }
      }
      return { ...selected, key: priceInventory.key };
    }
    findPricingByQtyBreakD2C(pplPricing, quantity) {
      const sorted = [...pplPricing?.Pricing || []].sort((a, b) => a.QtyBreak - b.QtyBreak);
      if (!sorted.length)
        return null;
      let selected = sorted[0];
      for (const item of sorted) {
        if (Number(quantity) >= Number(item.QtyBreak)) {
          selected = item;
        } else {
          break;
        }
      }
      return selected;
    }
    resolvePricing({ erpNumber, pplPricing }, quantity) {
      return theme.customer.isB2B ? this.findPricingByQtyBreak(erpNumber, quantity) : this.findPricingByQtyBreakD2C(pplPricing, quantity);
    }
  };
  var storageExtension = {
    save(data) {
      const keys = data.map(({ key }) => key);
      const priceInventory = this.get().filter(({ key }) => !keys.includes(key));
      this.set(this.checkExpiry([...data, ...priceInventory]).slice(0, 500));
    },
    find(erpNumber) {
      const priceInventory = this.get();
      const found = priceInventory.find(({ key }) => key === generateKey(erpNumber));
      if (!found)
        return null;
      if (new Date(found.expiresAt).getTime() < Date.now()) {
        return null;
      }
      return found;
    },
    // Filter out expired items
    checkExpiry(data) {
      return data.filter(({ key, expiresAt, ...rest }) => {
        return new Date(expiresAt).getTime() > Date.now();
      });
    }
  };
  function generateKey(erpNumber) {
    if (!window.gic_customer)
      return "";
    return JSON.stringify([
      "GIC",
      String(window.gic_customer.CustomerID),
      String(window.gic_customer.WarehouseName),
      String(window.gic_customer.ShippingProvince),
      String(erpNumber)
    ]);
  }
  window.PriceInventory = new PriceInventory2();

  // app/scripts/utils/cookie.js
  var cookie = {
    get: function(name) {
      const nameEQ = name + "=";
      const ca = document.cookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i].trim();
        if (c.indexOf(nameEQ) === 0) {
          const value = decodeURIComponent(c.substring(nameEQ.length, c.length));
          try {
            return JSON.parse(value);
          } catch (e) {
            return value;
          }
        }
      }
      return null;
    },
    set: function(name, value, days = 30) {
      const expires = /* @__PURE__ */ new Date();
      expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1e3);
      const cookieValue = typeof value === "object" ? JSON.stringify(value) : value;
      document.cookie = `${name}=${encodeURIComponent(cookieValue)};expires=${expires.toUTCString()};path=/`;
    },
    delete: function(name) {
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`;
    }
  };

  // app/scripts/modules/region.js
  var Region = class {
    get hasSelectedRegion() {
      return cookie.get("region") ? true : false;
    }
    get selectedRegionData() {
      const region = cookie.get("region");
      if (!region)
        return null;
      return region;
    }
    get selectedRegionTitle() {
      const region = this.selectedRegionData;
      if (!region)
        return null;
      return region.title;
    }
  };
  window.Region = new Region();

  // app/scripts/components/foreignMarkets.js
  var foreignMarkets = class extends HTMLElement {
    constructor() {
      super();
      this.querySelectorAll(".js-multi-shop")?.forEach((item) => {
        item.addEventListener("click", (e) => {
          const element = item;
          const type = element.className.includes("languages") ? "language_code" : "country_code";
          const target = this.querySelector(`[name="${type}"]`);
          target.value = element.dataset.value;
          this.querySelector("form").submit();
        });
      });
      this.querySelectorAll("details").forEach((item) => {
        item.addEventListener("click", (e) => {
          this.querySelectorAll("details").forEach((detail) => {
            if (detail != item) {
              detail.removeAttribute("open");
            }
          });
        });
      });
      this.addEventListener("change", ({ target }) => {
        if (!target.hasAttribute("auto-submit"))
          return;
        this.querySelector("form").submit();
      });
    }
  };
  customElements.define("foreign-markets", foreignMarkets);

  // app/scripts/utils/currencies.js
  var multiCurrency = {};
  var moneyFormat = theme.settings.moneyFormat;
  multiCurrency.moneyFormats = {
    USD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} USD"
    },
    EUR: {
      money_format: "&euro;{{amount}}",
      money_with_currency_format: "&euro;{{amount}} EUR"
    },
    GBP: {
      money_format: "&pound;{{amount}}",
      money_with_currency_format: "&pound;{{amount}} GBP"
    },
    CAD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} CAD"
    },
    ALL: {
      money_format: "Lek {{amount}}",
      money_with_currency_format: "Lek {{amount}} ALL"
    },
    DZD: {
      money_format: "DA {{amount}}",
      money_with_currency_format: "DA {{amount}} DZD"
    },
    AOA: {
      money_format: "Kz{{amount}}",
      money_with_currency_format: "Kz{{amount}} AOA"
    },
    ARS: {
      money_format: "${{amount_with_comma_separator}}",
      money_with_currency_format: "${{amount_with_comma_separator}} ARS"
    },
    AMD: {
      money_format: "{{amount}} AMD",
      money_with_currency_format: "{{amount}} AMD"
    },
    AWG: {
      money_format: "Afl{{amount}}",
      money_with_currency_format: "Afl{{amount}} AWG"
    },
    AUD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} AUD"
    },
    BBD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} Bds"
    },
    AZN: {
      money_format: "m.{{amount}}",
      money_with_currency_format: "m.{{amount}} AZN"
    },
    BDT: {
      money_format: "Tk {{amount}}",
      money_with_currency_format: "Tk {{amount}} BDT"
    },
    BSD: {
      money_format: "BS${{amount}}",
      money_with_currency_format: "BS${{amount}} BSD"
    },
    BHD: {
      money_format: "{{amount}}0 BD",
      money_with_currency_format: "{{amount}}0 BHD"
    },
    BYR: {
      money_format: "Br {{amount}}",
      money_with_currency_format: "Br {{amount}} BYR"
    },
    BZD: {
      money_format: "BZ${{amount}}",
      money_with_currency_format: "BZ${{amount}} BZD"
    },
    BTN: {
      money_format: "Nu {{amount}}",
      money_with_currency_format: "Nu {{amount}} BTN"
    },
    BAM: {
      money_format: "KM {{amount_with_comma_separator}}",
      money_with_currency_format: "KM {{amount_with_comma_separator}} BAM"
    },
    BRL: {
      money_format: "R$ {{amount_with_comma_separator}}",
      money_with_currency_format: "R$ {{amount_with_comma_separator}} BRL"
    },
    BOB: {
      money_format: "Bs{{amount_with_comma_separator}}",
      money_with_currency_format: "Bs{{amount_with_comma_separator}} BOB"
    },
    BWP: {
      money_format: "P{{amount}}",
      money_with_currency_format: "P{{amount}} BWP"
    },
    BND: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} BND"
    },
    BGN: {
      money_format: "{{amount}} \u043B\u0432",
      money_with_currency_format: "{{amount}} \u043B\u0432 BGN"
    },
    MMK: {
      money_format: "K{{amount}}",
      money_with_currency_format: "K{{amount}} MMK"
    },
    KHR: {
      money_format: "KHR{{amount}}",
      money_with_currency_format: "KHR{{amount}}"
    },
    KYD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} KYD"
    },
    XAF: {
      money_format: "FCFA{{amount}}",
      money_with_currency_format: "FCFA{{amount}} XAF"
    },
    CLP: {
      money_format: "${{amount_no_decimals}}",
      money_with_currency_format: "${{amount_no_decimals}} CLP"
    },
    CNY: {
      money_format: "&#165;{{amount}}",
      money_with_currency_format: "&#165;{{amount}} CNY"
    },
    COP: {
      money_format: "${{amount_with_comma_separator}}",
      money_with_currency_format: "${{amount_with_comma_separator}} COP"
    },
    CRC: {
      money_format: "&#8353; {{amount_with_comma_separator}}",
      money_with_currency_format: "&#8353; {{amount_with_comma_separator}} CRC"
    },
    HRK: {
      money_format: "{{amount_with_comma_separator}} kn",
      money_with_currency_format: "{{amount_with_comma_separator}} kn HRK"
    },
    CZK: {
      money_format: "{{amount_with_comma_separator}} K&#269;",
      money_with_currency_format: "{{amount_with_comma_separator}} K&#269;"
    },
    DKK: {
      money_format: "{{amount_with_comma_separator}}",
      money_with_currency_format: "kr.{{amount_with_comma_separator}}"
    },
    DOP: {
      money_format: "RD$ {{amount}}",
      money_with_currency_format: "RD$ {{amount}}"
    },
    XCD: {
      money_format: "${{amount}}",
      money_with_currency_format: "EC${{amount}}"
    },
    EGP: {
      money_format: "LE {{amount}}",
      money_with_currency_format: "LE {{amount}} EGP"
    },
    ETB: {
      money_format: "Br{{amount}}",
      money_with_currency_format: "Br{{amount}} ETB"
    },
    XPF: {
      money_format: "{{amount_no_decimals_with_comma_separator}} XPF",
      money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} XPF"
    },
    FJD: {
      money_format: "${{amount}}",
      money_with_currency_format: "FJ${{amount}}"
    },
    GMD: {
      money_format: "D {{amount}}",
      money_with_currency_format: "D {{amount}} GMD"
    },
    GHS: {
      money_format: "GH&#8373;{{amount}}",
      money_with_currency_format: "GH&#8373;{{amount}}"
    },
    GTQ: {
      money_format: "Q{{amount}}",
      money_with_currency_format: "{{amount}} GTQ"
    },
    GYD: {
      money_format: "G${{amount}}",
      money_with_currency_format: "${{amount}} GYD"
    },
    GEL: {
      money_format: "{{amount}} GEL",
      money_with_currency_format: "{{amount}} GEL"
    },
    HNL: {
      money_format: "L {{amount}}",
      money_with_currency_format: "L {{amount}} HNL"
    },
    HKD: {
      money_format: "${{amount}}",
      money_with_currency_format: "HK${{amount}}"
    },
    HUF: {
      money_format: "{{amount_no_decimals_with_comma_separator}}",
      money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} Ft"
    },
    ISK: {
      money_format: "{{amount_no_decimals}} kr",
      money_with_currency_format: "{{amount_no_decimals}} kr ISK"
    },
    INR: {
      money_format: "Rs. {{amount}}",
      money_with_currency_format: "Rs. {{amount}}"
    },
    IDR: {
      money_format: "{{amount_with_comma_separator}}",
      money_with_currency_format: "Rp {{amount_with_comma_separator}}"
    },
    ILS: {
      money_format: "{{amount}} NIS",
      money_with_currency_format: "{{amount}} NIS"
    },
    JMD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} JMD"
    },
    JPY: {
      money_format: "&#165;{{amount_no_decimals}}",
      money_with_currency_format: "&#165;{{amount_no_decimals}} JPY"
    },
    JEP: {
      money_format: "&pound;{{amount}}",
      money_with_currency_format: "&pound;{{amount}} JEP"
    },
    JOD: {
      money_format: "{{amount}}0 JD",
      money_with_currency_format: "{{amount}}0 JOD"
    },
    KZT: {
      money_format: "{{amount}} KZT",
      money_with_currency_format: "{{amount}} KZT"
    },
    KES: {
      money_format: "KSh{{amount}}",
      money_with_currency_format: "KSh{{amount}}"
    },
    KWD: {
      money_format: "{{amount}}0 KD",
      money_with_currency_format: "{{amount}}0 KWD"
    },
    KGS: {
      money_format: "\u043B\u0432{{amount}}",
      money_with_currency_format: "\u043B\u0432{{amount}}"
    },
    LVL: {
      money_format: "Ls {{amount}}",
      money_with_currency_format: "Ls {{amount}} LVL"
    },
    LBP: {
      money_format: "L&pound;{{amount}}",
      money_with_currency_format: "L&pound;{{amount}} LBP"
    },
    LTL: {
      money_format: "{{amount}} Lt",
      money_with_currency_format: "{{amount}} Lt"
    },
    MGA: {
      money_format: "Ar {{amount}}",
      money_with_currency_format: "Ar {{amount}} MGA"
    },
    MKD: {
      money_format: "\u0434\u0435\u043D {{amount}}",
      money_with_currency_format: "\u0434\u0435\u043D {{amount}} MKD"
    },
    MOP: {
      money_format: "MOP${{amount}}",
      money_with_currency_format: "MOP${{amount}}"
    },
    MVR: {
      money_format: "Rf{{amount}}",
      money_with_currency_format: "Rf{{amount}} MRf"
    },
    MXN: {
      money_format: "$ {{amount}}",
      money_with_currency_format: "$ {{amount}} MXN"
    },
    MYR: {
      money_format: "RM{{amount}} MYR",
      money_with_currency_format: "RM{{amount}} MYR"
    },
    MUR: {
      money_format: "Rs {{amount}}",
      money_with_currency_format: "Rs {{amount}} MUR"
    },
    MDL: {
      money_format: "{{amount}} MDL",
      money_with_currency_format: "{{amount}} MDL"
    },
    MAD: {
      money_format: "{{amount}} dh",
      money_with_currency_format: "Dh {{amount}} MAD"
    },
    MNT: {
      money_format: "{{amount_no_decimals}} &#8366",
      money_with_currency_format: "{{amount_no_decimals}} MNT"
    },
    MZN: {
      money_format: "{{amount}} Mt",
      money_with_currency_format: "Mt {{amount}} MZN"
    },
    NAD: {
      money_format: "N${{amount}}",
      money_with_currency_format: "N${{amount}} NAD"
    },
    NPR: {
      money_format: "Rs{{amount}}",
      money_with_currency_format: "Rs{{amount}} NPR"
    },
    ANG: {
      money_format: "&fnof;{{amount}}",
      money_with_currency_format: "{{amount}} NA&fnof;"
    },
    NZD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} NZD"
    },
    NIO: {
      money_format: "C${{amount}}",
      money_with_currency_format: "C${{amount}} NIO"
    },
    NGN: {
      money_format: "&#8358;{{amount}}",
      money_with_currency_format: "&#8358;{{amount}} NGN"
    },
    NOK: {
      money_format: "kr {{amount_with_comma_separator}}",
      money_with_currency_format: "kr {{amount_with_comma_separator}} NOK"
    },
    OMR: {
      money_format: "{{amount_with_comma_separator}} OMR",
      money_with_currency_format: "{{amount_with_comma_separator}} OMR"
    },
    PKR: {
      money_format: "Rs.{{amount}}",
      money_with_currency_format: "Rs.{{amount}} PKR"
    },
    PGK: {
      money_format: "K {{amount}}",
      money_with_currency_format: "K {{amount}} PGK"
    },
    PYG: {
      money_format: "Gs. {{amount_no_decimals_with_comma_separator}}",
      money_with_currency_format: "Gs. {{amount_no_decimals_with_comma_separator}} PYG"
    },
    PEN: {
      money_format: "S/. {{amount}}",
      money_with_currency_format: "S/. {{amount}} PEN"
    },
    PHP: {
      money_format: "&#8369;{{amount}}",
      money_with_currency_format: "&#8369;{{amount}} PHP"
    },
    PLN: {
      money_format: "{{amount_with_comma_separator}} zl",
      money_with_currency_format: "{{amount_with_comma_separator}} zl PLN"
    },
    QAR: {
      money_format: "QAR {{amount_with_comma_separator}}",
      money_with_currency_format: "QAR {{amount_with_comma_separator}}"
    },
    RON: {
      money_format: "{{amount_with_comma_separator}} lei",
      money_with_currency_format: "{{amount_with_comma_separator}} lei RON"
    },
    RUB: {
      money_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
      money_with_currency_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB"
    },
    RWF: {
      money_format: "{{amount_no_decimals}} RF",
      money_with_currency_format: "{{amount_no_decimals}} RWF"
    },
    WST: {
      money_format: "WS$ {{amount}}",
      money_with_currency_format: "WS$ {{amount}} WST"
    },
    SAR: {
      money_format: "{{amount}} SR",
      money_with_currency_format: "{{amount}} SAR"
    },
    STD: {
      money_format: "Db {{amount}}",
      money_with_currency_format: "Db {{amount}} STD"
    },
    RSD: {
      money_format: "{{amount}} RSD",
      money_with_currency_format: "{{amount}} RSD"
    },
    SCR: {
      money_format: "Rs {{amount}}",
      money_with_currency_format: "Rs {{amount}} SCR"
    },
    SGD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} SGD"
    },
    SYP: {
      money_format: "S&pound;{{amount}}",
      money_with_currency_format: "S&pound;{{amount}} SYP"
    },
    ZAR: {
      money_format: "R {{amount}}",
      money_with_currency_format: "R {{amount}} ZAR"
    },
    KRW: {
      money_format: "&#8361;{{amount_no_decimals}}",
      money_with_currency_format: "&#8361;{{amount_no_decimals}} KRW"
    },
    LKR: {
      money_format: "Rs {{amount}}",
      money_with_currency_format: "Rs {{amount}} LKR"
    },
    SEK: {
      money_format: "{{amount_no_decimals}} kr",
      money_with_currency_format: "{{amount_no_decimals}} kr SEK"
    },
    CHF: {
      money_format: "SFr. {{amount}}",
      money_with_currency_format: "SFr. {{amount}} CHF"
    },
    TWD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} TWD"
    },
    THB: {
      money_format: "{{amount}} &#xe3f;",
      money_with_currency_format: "{{amount}} &#xe3f; THB"
    },
    TZS: {
      money_format: "{{amount}} TZS",
      money_with_currency_format: "{{amount}} TZS"
    },
    TTD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} TTD"
    },
    TND: {
      money_format: "{{amount}}",
      money_with_currency_format: "{{amount}} DT"
    },
    TRY: {
      money_format: "{{amount}}TL",
      money_with_currency_format: "{{amount}}TL"
    },
    UGX: {
      money_format: "Ush {{amount_no_decimals}}",
      money_with_currency_format: "Ush {{amount_no_decimals}} UGX"
    },
    UAH: {
      money_format: "\u20B4{{amount}}",
      money_with_currency_format: "\u20B4{{amount}} UAH"
    },
    AED: {
      money_format: "Dhs. {{amount}}",
      money_with_currency_format: "Dhs. {{amount}} AED"
    },
    UYU: {
      money_format: "${{amount_with_comma_separator}}",
      money_with_currency_format: "${{amount_with_comma_separator}} UYU"
    },
    VUV: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}}VT"
    },
    VEF: {
      money_format: "Bs. {{amount_with_comma_separator}}",
      money_with_currency_format: "Bs. {{amount_with_comma_separator}} VEF"
    },
    VND: {
      money_format: "{{amount_no_decimals_with_comma_separator}}&#8363;",
      money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} VND"
    },
    XBT: {
      money_format: "{{amount_no_decimals}} BTC",
      money_with_currency_format: "{{amount_no_decimals}} BTC"
    },
    XOF: {
      money_format: "CFA{{amount}}",
      money_with_currency_format: "CFA{{amount}} XOF"
    },
    ZMW: {
      money_format: "K{{amount_no_decimals_with_comma_separator}}",
      money_with_currency_format: "ZMW{{amount_no_decimals_with_comma_separator}}"
    }
  };
  multiCurrency.formatMoney = function(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    let value = "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;
    function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      const parts = number.split(".");
      const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
      const centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }
    return formatString.replace(placeholderRegex, value);
  };
  Object.assign(Number.prototype, {
    toCurrency: function() {
      return multiCurrency.formatMoney(this, moneyFormat);
    }
  });
  Object.assign(String.prototype, {
    toCurrency: function() {
      return multiCurrency.formatMoney(this, moneyFormat);
    }
  });

  // app/scripts/components/quantity-input.js
  var { debounceTime: debounceTime3 } = theme;
  var QuantityInput = class extends HTMLElement {
    constructor() {
      super();
      const minusBtn = this.querySelector(".js-minus-btn");
      const plusBtn = this.querySelector(".js-plus-btn");
      const input = this.querySelector(".js-quantity-input");
      this.prevValue = input.value;
      this.input = input;
      this.onChangeCallbacks = [];
      if (!minusBtn || !plusBtn || !input)
        return;
      this.min = this.#getNumericAttr("min", 1);
      this.max = this.#getNumericAttr("max", Infinity);
      plusBtn.addEventListener("click", this.increment.bind(this));
      minusBtn.addEventListener("click", this.decrement.bind(this));
      input.addEventListener("focus", this.handleInputFocus.bind(this));
      input.addEventListener(
        "input",
        debounceTime3(() => {
          const value = Number(input.value);
          if (isNaN(value))
            return;
          if (value > this.max) {
            input.value = this.max;
          }
          if (!this.validateStep()) {
            return;
          }
          this.onChangeCallbacks.forEach((cb) => cb(Number(input.value)));
        }, 500)
      );
      input.addEventListener("blur", this.handleInputBlur.bind(this));
    }
    validateAndDispatch(event) {
      const { min, step, value } = this.input;
      if (!this.validateStep()) {
        const nMin = Number(min) || 0;
        const nStep = Number(step) || 1;
        const nValue = Math.max(Number(value) || 0, nMin);
        const stepsFromMin = Math.ceil((nValue - nMin) / nStep);
        this.input.value = String(nMin + stepsFromMin * nStep);
        this.input.setCustomValidity("");
      }
      if (this.prevValue && this.prevValue == this.input.value)
        return;
      this.#dispatchChange(Number(this.input.value));
      this.prevValue = this.input.value;
    }
    handleInputBlur(event) {
      event.stopPropagation();
      this.validateAndDispatch(event);
      this.prevValue = null;
    }
    handleInputFocus(e) {
      e.stopPropagation();
      this.prevValue = this.input.value;
      this.input.value = "";
    }
    increment(e) {
      e.stopPropagation();
      const current = Number(this.input.value) || 0;
      if (current < this.max) {
        this.input.stepUp();
        this.validateAndDispatch();
      }
    }
    decrement(e) {
      e.stopPropagation();
      const current = Number(this.input.value) || 0;
      const nextValue = current - this.#getNumericAttr("step", 1);
      if (nextValue <= this.min) {
        this.input.value = this.min;
      }
      if (current > this.min) {
        this.input.stepDown();
      }
      this.validateAndDispatch();
    }
    get value() {
      return +this.input.value;
    }
    set value(value) {
      if (!Number(value)) {
        console.warn("QuantityInput: value is not a number");
        return;
      }
      this.input.value = String(value);
    }
    get step() {
      return +this.input.step;
    }
    stepUp(value) {
      if (!value)
        return;
      this.input.stepUp(Number(value));
      this.validateAndDispatch();
    }
    stepDown(value) {
      if (!value)
        return;
      this.input.stepDown(Number(value));
      this.validateAndDispatch();
    }
    onChange(cb) {
      this.onChangeCallbacks.push(cb);
    }
    updateStep(step) {
      if (step == this.input.step)
        return;
      const currentValue = this.input.value;
      this.input.setAttribute("step", step);
      this.input.setAttribute("min", step);
      this.min = this.#getNumericAttr("min", 1);
      if (this.value < step) {
        this.input.value = step;
      } else if ((this.value - this.min) % step !== 0) {
        const stepsFromMin = Math.floor((this.value - this.min) / step);
        this.input.value = String(this.min + stepsFromMin * step);
      }
      if (currentValue != this.input.value) {
        this.validateAndDispatch();
      }
    }
    validateStep() {
      const { min, step, value } = this.input;
      if (!this.input.value.length)
        return false;
      const nMin = Number(min) || 0;
      const nStep = Number(step) || 1;
      const nValue = Number(value);
      if (!Number.isFinite(nValue) || nValue < nMin)
        return false;
      const remainder = (nValue - nMin) % nStep;
      const isOnStep = Math.abs(remainder) < Number.EPSILON || Math.abs(remainder - nStep) < Number.EPSILON;
      if (!isOnStep) {
        const message = window.theme?.string?.mustBeMultiple || "The value must be a multiple of {step}";
        this.input.setCustomValidity(message.replaceAll("{step}", nStep));
        this.input.reportValidity();
        return false;
      }
      this.input.setCustomValidity("");
      return true;
    }
    #getNumericAttr(name, fallback) {
      const raw = this.input?.getAttribute(name);
      const n = Number(raw);
      return Number.isFinite(n) ? n : fallback;
    }
    #dispatchChange(numericValue) {
      this.onChangeCallbacks.forEach((cb) => cb(numericValue));
    }
  };
  customElements.define("quantity-input", QuantityInput);

  // app/scripts/components/drawer.js
  var { disableScroll: disableScroll2, enableScroll: enableScroll2 } = theme;
  var Drawer = class extends HTMLElement {
    constructor() {
      super();
      this.initCloseButtons();
    }
    open() {
      this.classList.add("is-open");
      disableScroll2();
    }
    close() {
      this.classList.remove("is-open");
      enableScroll2();
    }
    initCloseButtons() {
      const closeButtons = this.querySelectorAll(".js-close-button");
      closeButtons.forEach((button) => {
        button.addEventListener("click", () => this.close());
      });
    }
  };

  // app/scripts/components/CartDrawer.js
  var { disableScroll: disableScroll3, enableScroll: enableScroll3 } = theme;
  var CartDrawer = class extends Drawer {
    constructor() {
      super();
    }
    async connectedCallback() {
      await customElements.whenDefined("cart-component");
      this.cartComponent = this.querySelector("cart-component");
      this.cartContainer = this.cartComponent.querySelector("main");
      document.addEventListener("keyup", this.handleKeyUp.bind(this));
    }
    update(data) {
      this.cartComponent?.updateLayout(data);
      return this;
    }
    open(lineItemKey) {
      this.classList.add("is-open");
      disableScroll3();
      if (lineItemKey)
        setTimeout(() => this.scrollTo(lineItemKey), 200);
    }
    close() {
      this.classList.remove("is-open");
      enableScroll3();
      this.scrollToTop();
    }
    scrollTo(key) {
      const foundLineItem = this.cartComponent.findLineItem(key);
      foundLineItem?.scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
    scrollToTop() {
      this.cartContainer.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
    handleKeyUp(event) {
      switch (event.key) {
        case "Escape":
          this.close();
          break;
      }
    }
  };
  customElements.define("cart-drawer", CartDrawer);

  // app/scripts/components/HeaderCart.js
  var { drawers, delay: delay3 } = theme;
  var HeaderCart = class extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.cartItemCount = this.querySelector(".js-cart-item-count");
      this.popupApproval = this.querySelector("#header-cart-approval");
      this.initButtonsEvent();
      this.listenClick();
    }
    open() {
      this.classList.add("is-open");
    }
    close() {
      this.classList.remove("is-open");
    }
    update(data) {
      try {
        if (!data)
          return;
        const { sections } = data;
        if (!sections)
          throw new Error("sections is required");
        const section2 = sections[this.sectionId];
        if (!section2)
          return;
        const layout = new DOMParser().parseFromString(section2, "text/html");
        const elementsToUpdate = this.querySelectorAll(".js-layout-update");
        elementsToUpdate.forEach((elm) => {
          const foundElement = layout.getElementById(elm.dataset.updateId);
          if (foundElement) {
            elm.innerHTML = foundElement.innerHTML;
          }
        });
        const cartItemCount = layout.getElementById("header-cart-popup-item-count");
        this.dataset.count = cartItemCount.innerHTML;
        return this;
      } catch (error) {
        throw error;
      }
    }
    updateItemsCount(count) {
      this.dataset.count = count;
      this.cartItemCount.innerHTML = count;
    }
    initButtonsEvent() {
      const viewCartButton = this.querySelector("button[name='view-cart']");
      this.querySelectorAll(".js-close-popup").forEach((button) => {
        button.addEventListener("click", this.close.bind(this));
      });
      viewCartButton?.addEventListener("click", async () => {
        this.close();
        if (!theme.customer.isB2B) {
          await delay3(100);
          theme.drawers.cart.open();
        } else {
          window.location.href = theme.routes.cartUrl;
        }
      });
    }
    listenClick() {
      this.addEventListener("click", (e) => {
        if (!theme.customer.isB2B) {
          e.preventDefault();
          theme.drawers.cart?.open();
        }
      });
    }
    setState(state) {
      switch (state) {
        case "open-approval":
          this.popupApproval?.classList.add("is-open");
          break;
        case "reset":
          this.classList.remove("is-open");
          break;
      }
    }
  };
  customElements.define("header-cart", HeaderCart);

  // app/scripts/modules/job-lists/job-lists.api.js
  function translateError(code, fallback = code) {
    return theme?.string?.jobLists?.errors?.[code] || fallback;
  }
  var JobListsAPI = {
    async create(data) {
      try {
        const payload = { ...data };
        if (!payload.companyGid)
          delete payload.companyGid;
        const createFailedMessage = translateError("CREATE_FAILED", "We couldn't create your Job List. Please try again.");
        const response = await teifiWishlistApi.create(payload).catch((error) => {
          console.error("Failed to create job list:", error);
          throw new Error(createFailedMessage);
        });
        if (!response?.metaobjectGid) {
          throw new Error(translateError(response?.error, createFailedMessage));
        }
        return response;
      } catch (error) {
        throw error;
      }
    },
    async delete(jobListId) {
      try {
        if (!jobListId)
          throw new Error("No jobListId provided");
        return await teifiWishlistApi.delete(jobListId);
      } catch (error) {
        throw error;
      }
    },
    async fetchList(options = {}) {
      try {
        const { search = "", sort = "updatedAt:desc", page = 1, limit = 10 } = options;
        const response = await teifiWishlistApi.find({
          search,
          sort,
          page,
          limit
        });
        response.items = response.items.map((item) => ({
          ...item,
          id: item.metaobjectGid.split("/").pop()
        }));
        return response;
      } catch (error) {
        throw error;
      }
    },
    async fetchJobList(id) {
      try {
        return await teifiWishlistApi.findById(sanitizeId(id));
      } catch (error) {
        throw error;
      }
    },
    async update(jobListId, data) {
      try {
        if (!jobListId)
          throw new Error("No jobListId provided");
        return await teifiWishlistApi.update(sanitizeId(jobListId), data);
      } catch (error) {
        throw error;
      }
    },
    async sendShare(jobListId, data) {
      try {
        const { emails, senderName, ...rest } = data;
        if (!emails || !senderName)
          throw new Error("Missing required fields");
        const response = await Promise.all(
          emails.split(",").map(async (email) => {
            const res = await teifiWishlistApi.updateCustomerPermission(jobListId, {
              email: email.trim(),
              senderName,
              ...rest
            });
            if (res.error) {
              return { ...res, email };
            }
            return res;
          })
        );
        const errorItems = response.filter((item) => item.error).slice(0, 5);
        if (errorItems.length > 0) {
          const { error: firstError } = errorItems[0] || {};
          const message = response.length === 1 ? translateError(firstError) : errorItems.map((item) => `${(item.email || "").trim()}: ${translateError(item.error)}`).join("<br>");
          throw new Error(message);
        }
        return response;
      } catch (error) {
        throw error;
      }
    },
    async sendCopy(jobListId, data) {
      try {
        const { emails, senderName, ...rest } = data;
        if (!emails || !senderName)
          throw new Error("Missing required fields");
        const response = await Promise.all(
          emails.split(",").map(async (email) => {
            const res = await teifiWishlistApi.copy(jobListId, {
              email: email.trim(),
              senderName,
              ...rest
            });
            if (res.error) {
              return { ...res, email };
            }
            return res;
          })
        );
        if (response.some((item) => item.error)) {
          throw new Error(
            response.filter((item) => item.error).splice(0, 5).map((item) => `${item.email}: ${item.error}`).join("<br>")
          );
        }
        return response;
      } catch (error) {
        throw error;
      }
    },
    fetchAddedProducts(jobListIds) {
      try {
        return teifiWishlistApi.getProductWishlistsByProductIds(jobListIds);
      } catch (error) {
        throw error;
      }
    },
    async updateCustomerPermission(jobListId, data) {
      try {
        return await teifiWishlistApi.updateCustomerPermission(jobListId, data);
      } catch (error) {
        throw error;
      }
    },
    async updateCompanyPermission(jobListId, data) {
      try {
        return await teifiWishlistApi.updateCompanyPermission(jobListId, data);
      } catch (error) {
        throw error;
      }
    }
  };
  function sanitizeId(id) {
    if (id == null)
      throw new Error(`sanitizeId: received ${id}`);
    const strId = String(id);
    if (strId.includes("gid://shopify")) {
      return strId.split("/").pop();
    }
    return strId;
  }
  var job_lists_api_default = JobListsAPI;

  // app/scripts/modules/job-lists/index.js
  var JobLists = class {
    constructor() {
      this.list = /* @__PURE__ */ new Map();
      this.isFetchedList = false;
      this.isFetchedAll = false;
      this.modal = {
        create: document.querySelector("popup-job-list"),
        update: document.querySelector("popup-job-list"),
        delete: document.querySelector("popup-delete-confirm"),
        share: document.querySelector("popup-share-list"),
        sendCopy: document.querySelector("popup-send-copy"),
        shareList: document.querySelector("popup-send-copy"),
        copyList: document.querySelector("popup-copy-list"),
        grantPermission: document.querySelector("popup-grant-permission"),
        shareBilling: document.querySelector("popup-share-billing"),
        selectJobList: document.querySelector("popup-select-joblist")
      };
      this.addedProductsList = /* @__PURE__ */ new Map();
      this.checkAddedProducts();
    }
    async create(data) {
      try {
        this.validate(data);
        const createdJobList = await job_lists_api_default.create(data);
        const id = createdJobList.metaobjectGid.split("/").pop();
        this.list.set(id, createdJobList);
        return { ...createdJobList, id };
      } catch (error) {
        throw error;
      }
    }
    async delete(jobListId) {
      try {
        const response = await job_lists_api_default.delete(jobListId);
        this.list.delete(sanitizeId(jobListId));
        return response;
      } catch (error) {
        throw error;
      }
    }
    validate(data) {
      ["name", "description", "items", "customerGid"].forEach((field) => {
        if (!(field in data) || data[field] === void 0) {
          throw new Error(`${field} is required`);
        }
      });
    }
    /**
     * Updates a job list with the provided data
     * @async
     * @param {number|string} jobListId - The ID of the job list to update
     * @param {Object} data - The data to update the job list with
     * @param {string} [data.name] - The new name for the job list
     * @param {string} [data.description] - The new description for the job list
     * @returns {Promise<Object>} A promise that resolves to the updated job list
     * @throws {Error} If there's an error updating the job list
     */
    async update(jobListId, data) {
      try {
        this.validate(data);
        const updatedJobList = await job_lists_api_default.update(jobListId, data);
        this.list.delete(sanitizeId(jobListId));
        return updatedJobList;
      } catch (error) {
        throw error;
      }
    }
    async nextSharingStep(step, jobListId, data) {
      switch (step) {
        case 1:
          const value = await this.modal.share.open();
          return this.nextSharingStep(value === "send-copy" ? 2 : 3, jobListId);
        case 2: {
          const value2 = await this.modal.sendCopy.open("copy", jobListId);
          if (value2 === "back") {
            return this.nextSharingStep(1, jobListId);
          }
          break;
        }
        case 3: {
          const value2 = await this.modal.grantPermission.open();
          if (!value2)
            return;
          if (value2 === "back") {
            return this.nextSharingStep(1, jobListId);
          }
          switch (value2?.shareOption) {
            case "shared-individually":
              this.nextSharingStep(4, jobListId, value2);
              break;
            case "shared-with-billing-account":
              this.nextSharingStep(5, jobListId, value2);
              break;
            default:
              this.nextSharingStep(4, jobListId, value2);
              break;
          }
          break;
        }
        case 4: {
          const value2 = await this.modal.shareList.open("share", jobListId, data);
          if (value2 === "back") {
            return this.nextSharingStep(3, jobListId, data);
          }
          break;
        }
        case 5: {
          const value2 = await this.modal.shareBilling.open(jobListId, data);
          if (value2 === "back") {
            return this.nextSharingStep(3, jobListId, data);
          }
          break;
        }
      }
    }
    async sendShare(jobListId, data) {
      try {
        return await job_lists_api_default.sendShare(jobListId, data);
      } catch (error) {
        throw error;
      }
    }
    async sendCopy(jobListId, data) {
      try {
        return await job_lists_api_default.sendCopy(jobListId, data);
      } catch (error) {
        throw error;
      }
    }
    async share(jobListId) {
      try {
        this.nextSharingStep(1, jobListId);
      } catch (error) {
        throw error;
      }
    }
    /**
     * Fetches the list of job lists with optional filtering and sorting.
     * @async
     * @param {Object} options - The options for fetching job lists
     * @param {string} [options.search] - Search term to filter job lists
     * @param {string} [options.sort] - Sort criteria for job lists
     * @returns {Promise<Array>} A promise that resolves to an array of job lists
     * @throws {Error} If there's an error fetching the job lists
     */
    async fetchJobLists(options = {}) {
      try {
        const response = await job_lists_api_default.fetchList(options);
        response.items.forEach((item) => {
          const id = item.metaobjectGid.split("/").pop();
          !this.list.has(id) && this.list.set(id, item);
        });
        this.isFetchedList = true;
        return response;
      } catch (error) {
        throw error;
      }
    }
    async getAll() {
      try {
        if (this.isFetchedAll) {
          return [...this.list.values()];
        }
        let { totalPages, items, page } = await job_lists_api_default.fetchList({ limit: 100 });
        const totalItemList = [...items];
        while (totalPages > page) {
          const { items: items2 } = await job_lists_api_default.fetchList({ page: page + 1, limit: 100 });
          totalItemList.push(...items2);
          page++;
        }
        totalItemList.forEach((item) => {
          const id = item.metaobjectGid.split("/").pop();
          !this.list.has(id) && this.list.set(id, item);
        });
        this.isFetchedAll = true;
        return totalItemList;
      } catch (error) {
        throw error;
      }
    }
    async fetchJobList(id) {
      try {
        const sanitizedId = sanitizeId(id);
        const cachedJobList = this.list.get(sanitizedId);
        if (cachedJobList)
          return cachedJobList;
        const response = await job_lists_api_default.fetchJobList(id);
        this.list.set(sanitizedId, response);
        return response;
      } catch (error) {
        throw error;
      }
    }
    async getJobLists() {
      try {
        if (!this.isFetchedList) {
          await this.fetchJobLists();
        }
        return [...this.list.values()];
      } catch (error) {
        throw error;
      }
    }
    async getById(jobListId) {
      try {
        return this.list.get(sanitizeId(jobListId)) || await this.fetchJobList(jobListId);
      } catch (error) {
        throw error;
      }
    }
    copyListFrom(originJobListId) {
      try {
        return {
          to: async (targetJobListId) => {
            return await this.copyList(originJobListId, targetJobListId);
          }
        };
      } catch (error) {
        throw error;
      }
    }
    async copyList(originJobListId, targetJobListId) {
      try {
        const originJobList = this.list.get(sanitizeId(originJobListId));
        const targetJobList = this.list.get(sanitizeId(targetJobListId));
        const targetItemsIds = targetJobList.items.map(({ variantGid }) => variantGid);
        const filteredItems = originJobList.items.filter(({ variantGid }) => !targetItemsIds.includes(variantGid));
        return await job_lists_api_default.update(targetJobListId, {
          ...targetJobList,
          items: [...targetJobList.items, ...filteredItems]
        });
      } catch (error) {
        throw error;
      }
    }
    async renderJobListOptions(selectElm, disabledJobListIds = []) {
      const list = await this.getAll();
      [...selectElm.options].forEach((option, index) => {
        if (index > 0)
          option.remove();
      });
      list.forEach((jobList) => {
        const option = document.createElement("option");
        option.value = jobList.id;
        option.textContent = jobList.name;
        if (disabledJobListIds.includes(jobList.id)) {
          option.disabled = true;
        }
        selectElm.appendChild(option);
      });
    }
    async checkAddedProducts() {
      try {
        await isTeifiWishlistReady();
        const jobListButtons = document.querySelectorAll(".js-job-list-button:not(.is-initialized)");
        if (!jobListButtons.length)
          return;
        const jobListIds = new Set([...jobListButtons].map((button) => button.dataset.productId));
        const response = await teifiWishlistApi.getProductWishlistsByProductIds([...jobListIds.values()]);
        const jobListMap = response.reduce((prev, next) => {
          prev[next.productId] = next.wishlists;
          return prev;
        }, {});
        jobListButtons.forEach((button) => {
          const wishlists = jobListMap[button.dataset.productId];
          if (wishlists.length) {
            button.classList.add("is-added");
          }
        });
      } catch (error) {
        throw error;
      }
    }
    async isAddedToList(variantGid) {
      const jobLists = await this.getAll();
      return jobLists.some((jobList) => jobList.items.some((item) => item.variantGid === variantGid));
    }
    async updateCompanyPermissions(jobListId, data) {
      try {
        return await job_lists_api_default.updateCompanyPermission(jobListId, data);
      } catch (error) {
        throw error;
      }
    }
    async updateCustomerPermission(jobListId, data) {
      try {
        return await job_lists_api_default.updateCustomerPermission(jobListId, data);
      } catch (error) {
        throw error;
      }
    }
    async fetchSharedJobList(id) {
      const url = `${teifiWishlistApi.baseUrl}/api/public/wishlists/${id}`;
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Failed to fetch shared job list: ${response.statusText}`);
      }
      return response.json();
    }
  };
  var job_lists_default = JobLists;

  // app/scripts/components/CardProduct.js
  var { moneyFormat: moneyFormat2 } = theme.settings;
  var {
    getRegionData: getRegionData3,
    countDecimals: countDecimals3,
    calculateRegionInventoryTotal: calculateRegionInventoryTotal3,
    getPickupQuantity: getPickupQuantity3,
    addQuantityAndUnitPrice: addQuantityAndUnitPrice2,
    getEcoFee: getEcoFee2,
    getCustomerProvinceCode: getCustomerProvinceCode2
  } = theme.utils;
  var CardProduct = class extends HTMLElement {
    _price = null;
    _source = null;
    _b2b_key = null;
    constructor() {
      super();
      this.form = this.querySelector("form");
      this.quantity = this.querySelector("quantity-input");
      this.JSONData = JSON.parse(this.querySelector("script[data-json]")?.textContent || "{}");
      this.unitPriceLabel = this.querySelector(".js-unit-price");
      this.selectRegionButton = this.querySelector(".js-select-region");
      this.pricingData = this.JSONData.pricing;
      this.priceLabel = this.querySelector(".js-price-value");
      this.ecoFeeLabels = this.querySelectorAll(".js-eco-fee");
      this.ecoFeeData = this.JSONData.ecoFee;
      this.currentEcoFee = 0;
      this.erpNumber = this.dataset.erpNumber;
      this.oversize = this.dataset.oversize;
      this.PCProducts = this.JSONData.PCProducts;
      this.myPartInput = this.querySelector("add-my-part");
      if (theme.customer.isB2B) {
        const selectedRegion = getRegionData3();
        const foundEcoFee = this.resolveEcoFee(selectedRegion);
        this.updateEcoFee(foundEcoFee);
        this.updateLocationName(theme.preferredLocation?.name);
      }
      this.initButtonEvents();
      this.handleSubmit = this.handleSubmit.bind(this);
      this.updateLayoutByRegion = this.updateLayoutByRegion.bind(this);
      this.handlePreferredLocationChange = this.handlePreferredLocationChange.bind(this);
    }
    set price(price) {
      if (isNaN(price)) {
        console.error("Price is not a number");
        return;
      }
      this._price = Number(price);
      this.updatePrice(this._price);
    }
    get price() {
      return this._price + this.currentEcoFee;
    }
    get source() {
      return this._source;
    }
    set source(source) {
      this._source = source;
    }
    get b2b_key() {
      return this._b2b_key;
    }
    set b2b_key(key) {
      this._b2b_key = key;
    }
    getCurrentQuantity() {
      const quantity = Number.parseInt(this.quantity?.value, 10);
      return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
    }
    async connectedCallback() {
      await customElements.whenDefined("quantity-input");
      this.initEvents();
      if (theme.customer.isB2B) {
        window.addEventListener("preferredLocation:change", this.handlePreferredLocationChange);
        this.quantity?.onChange(this.handleQuantityChange.bind(this));
      }
    }
    disconnectedCallback() {
      this.form?.removeEventListener("submit", this.handleSubmit);
      window.removeEventListener("regionSelected", this.updateLayoutByRegion);
      window.removeEventListener("preferredLocation:change", this.handlePreferredLocationChange);
    }
    initButtonEvents() {
      this.selectRegionButton?.addEventListener(
        "click",
        (e) => {
          e.stopPropagation();
          window.dispatchEvent(new CustomEvent("open-select-region"));
        },
        {}
      );
    }
    get properties() {
      const properties = { _source: this._source };
      if (theme.customer.isB2B) {
        properties._b2b_key = this._b2b_key;
        properties._b2b_price = String(this._price);
        this.myPartInput?.value && (properties._my_part_number = this.myPartInput.value);
      }
      if (this.currentEcoFee) {
        properties._ecofee = this.currentEcoFee;
      }
      if (countDecimals3(this._price) > 2) {
        properties._quantity = this.quantity.value;
      }
      return properties;
    }
    async handleSubmit(event) {
      try {
        event.preventDefault();
        this.setState("adding");
        const formData = new FormData(this.form);
        const quantity = +formData.get("quantity");
        const id = this.form.id.value;
        formData.append("sections", "drawer-cart-items,header-cart-popup");
        formData.append("sections_url", `${theme.routes.searchUrl}?q=[variants.id:${id}]`);
        formData.append("properties[_source]", this._source);
        if (theme.customer.isB2B) {
          this.myPartInput?.value ? formData.append("properties[_my_part_number]", this.myPartInput.value) : formData.delete("properties[_my_part_number]");
          formData.append("properties[_b2b_price]", String(this._price));
          formData.append("properties[_b2b_key]", this._b2b_key);
        }
        if (this.currentEcoFee) {
          formData.append("properties[_ecofee]", this.currentEcoFee);
        }
        if (countDecimals3(this._price) > 2) {
          addQuantityAndUnitPrice2(formData, this._price, quantity);
        }
        const dataToChange = await Cart.checkItemExists({
          id,
          quantity,
          erpNumber: this.erpNumber,
          price: this._price
        });
        if (dataToChange) {
          await Cart.change({
            data: {
              ...dataToChange,
              sections: formData.get("sections"),
              sections_url: formData.get("sections_url")
            },
            action: "add"
          });
        } else {
          await Cart.add(formData);
        }
        if (window.theme.routes.pageType == "cart") {
          window.location.reload();
        }
      } catch (error) {
        throw error;
      } finally {
        this.setState("reset");
      }
    }
    async initEvents() {
      this.form?.addEventListener("submit", this.handleSubmit);
      if (theme.customer.isB2B)
        return;
      const regionSelector = document.querySelector("select-region");
      if (regionSelector) {
        await customElements.whenDefined("select-region");
        window.addEventListener("regionSelected", this.updateLayoutByRegion);
        window.addEventListener("regionDetected", this.updateLayoutByRegion);
      }
      const selectedRegion = getRegionData3();
      selectedRegion && this.updateLayoutByRegion({ detail: { regionData: selectedRegion } });
      this.setState("fetched-price");
    }
    handlePreferredLocationChange(event) {
      const { preferredLocation } = event.detail;
      const priceInventory = window.PriceInventory.storage.find(this.erpNumber);
      this.updateLocationName(preferredLocation.name);
      priceInventory && this.updateB2BLayout(priceInventory?.data, preferredLocation);
      const foundRegion = theme.regionData.find((region) => region.title == preferredLocation.region);
      const foundEcoFee = this.resolveEcoFee(foundRegion, preferredLocation?.pc_number);
      this.updateEcoFee(foundEcoFee);
    }
    updateLayoutByRegion({ detail }) {
      const selectedRegion = detail.regionData;
      const { customer_id, location_id } = selectedRegion;
      const foundEcoFee = this.resolveEcoFee(selectedRegion);
      const foundShopLocation = theme.shopLocations.find((location2) => location2.id == location_id);
      const foundPCProduct = this.findPCProductAndUpdateLayout(foundShopLocation?.pc_number);
      const available = this.oversize === "false" && !!foundPCProduct?.InStock;
      const foundPricing = this.pricingData.find((pricing) => pricing.CustomerID == customer_id);
      this.setState(available ? "stock-available" : "stock-unavailable");
      this.updateEcoFee(foundEcoFee);
      if (foundPricing) {
        const sorted = [...foundPricing.Pricing || []].sort((a, b) => a.QtyBreak - b.QtyBreak);
        const { Pricing = 0, Source } = sorted[0] || {};
        const price = Number(Pricing) || 0;
        if (price) {
          this.price = price;
          this._source = Source;
          this.setState("price-available");
        } else {
          this.setState("price-unavailable");
        }
      } else {
        this.setState("price-unavailable");
      }
    }
    updateB2BLayout(priceInventory, shopLocation) {
      const { Quantity, WarehousesQuantities = [] } = priceInventory || {};
      const { b2bDeliveryQuantity } = theme.settings;
      const pickupQuantity = getPickupQuantity3(WarehousesQuantities, shopLocation, Quantity);
      const totalInventoryQuantity = b2bDeliveryQuantity === "region" ? calculateRegionInventoryTotal3(WarehousesQuantities, shopLocation, Quantity) : pickupQuantity;
      const pricing = PriceInventory.findPricingByQtyBreak(this.erpNumber, this.quantity?.value || 1);
      this.findPCProductAndUpdateLayout(shopLocation.pc_number);
      this.setState("fetched-price");
      if (!pricing) {
        this.setState("price-unavailable");
        return;
      }
      const { Pricing, Source, key } = pricing;
      this.price = +Pricing;
      this.source = Source;
      this.b2b_key = key;
      if (+Pricing === 0) {
        this.setState("price-unavailable");
        return;
      }
      if (totalInventoryQuantity) {
        this.updateTotalInventory(totalInventoryQuantity);
        if (pickupQuantity > 0) {
          this.updatePickupInventory(pickupQuantity);
          this.setState("pickup-available");
        } else {
          this.setState("pickup-unavailable");
        }
      } else {
        this.setState("stock-unavailable");
      }
    }
    findPCProductAndUpdateLayout(pcNumber) {
      if (!pcNumber)
        return;
      const foundPCProduct = this.PCProducts.find((pcProduct) => pcProduct.WarehouseName == pcNumber);
      this.updateQuantityStep(foundPCProduct?.MultipleSaleQty);
      this.updateMinQuantity(foundPCProduct?.MinimumOrderQty);
      return foundPCProduct;
    }
    resolveEcoFee(region, preferredLocationId) {
      const provinceCode = getCustomerProvinceCode2(region, preferredLocationId);
      return getEcoFee2(this.ecoFeeData, region, provinceCode);
    }
    updateEcoFee(ecoFee) {
      this.currentEcoFee = Number(ecoFee) || 0;
      if (!this.ecoFeeLabels.length)
        return;
      const ecoFeeMoney = theme.settings.moneyFormat.replace("{{amount}}", this.currentEcoFee.toFixed(2));
      this.ecoFeeLabels.forEach((label) => {
        if (this.currentEcoFee) {
          label.textContent = label.dataset.message.replace("{{money}}", ecoFeeMoney);
          label.classList.remove("hidden");
        } else {
          label.classList.add("hidden");
        }
      });
    }
    updatePrice(price) {
      if (!this.priceLabel)
        return;
      const totalPrice = Math.round((price + this.currentEcoFee) * 100) / 100;
      this.priceLabel.textContent = moneyFormat2.replace("{{amount}}", totalPrice.toFixed(2));
      this.handleAfterPriceUpdate();
    }
    updateUnitPrice(newUnitPrice) {
      if (!this.unitPriceLabel)
        return;
      if (newUnitPrice) {
        this.unitPriceLabel.textContent = `/ ${newUnitPrice}`;
        this.unitPriceLabel.classList.remove("hidden");
      } else {
        this.unitPriceLabel.classList.add("hidden");
      }
      this.handleAfterPriceUpdate();
    }
    updateTotalInventory(quantity) {
      this.querySelectorAll(".js-total-inventory").forEach((elm) => {
        elm.textContent = quantity;
      });
    }
    updatePickupInventory(quantity) {
      this.querySelectorAll(".js-pickup-inventory").forEach((elm) => {
        elm.textContent = quantity;
      });
    }
    updateQuantityStep(step) {
      if (!this.quantity || !step)
        return;
      this.quantity.updateStep(step);
      if (step > 1) {
        const messageElm = this.querySelector(".js-sold-multiples-message");
        if (messageElm) {
          messageElm.textContent = messageElm.dataset.message.replace("{{ sold_multiples }}", step);
        }
        this.setState("sold-multiples");
      } else {
        this.setState("sold-single");
      }
    }
    updateMinQuantity(number) {
      if (!this.quantity || !number)
        return;
      this.quantity.input.min = number;
    }
    updateLocationName(name) {
      const locationNameElm = this.querySelector(".js-location-name");
      if (!locationNameElm)
        return;
      const locationId = window.gic_customer.WarehouseName;
      const locationName = name || theme.shopLocations.find((location2) => location2.pc_number == locationId)?.name;
      locationNameElm.textContent = locationName;
    }
    handleQuantityChange(newQuantity) {
      const pricing = PriceInventory.findPricingByQtyBreak(this.erpNumber, newQuantity);
      if (!pricing)
        return;
      if (this._price != pricing.Pricing) {
        this.price = pricing.Pricing;
      }
    }
    setState(state) {
      switch (state) {
        case "stock-unavailable":
          this.classList.add("stock-unavailable");
          break;
        case "stock-available":
          this.classList.remove("stock-unavailable");
          break;
        case "pickup-unavailable":
          this.classList.add("pickup-unavailable");
          break;
        case "pickup-available":
          this.classList.remove("pickup-unavailable");
          break;
        case "sold-multiples":
          this.classList.add("sold-multiples");
          break;
        case "sold-single":
          this.classList.remove("sold-multiples");
          break;
        case "fetched-price":
          this.classList.remove("is-fetching-price");
          break;
        case "price-not-found":
          this.classList.remove("is-fetching-price");
          this.classList.add("price-missing");
          break;
        case "price-unavailable":
          this.classList.add("price-unavailable");
          break;
        case "price-available":
          this.classList.remove("price-unavailable");
          break;
        case "deleting":
          this.classList.add("is-loading", "is-deleting");
          break;
        case "adding":
          this.classList.add("is-loading", "is-atc-loading");
          break;
        case "reset":
          this.classList.remove("is-loading", "is-atc-loading", "is-deleting");
      }
    }
    // Override this method in child class
    handleAfterPriceUpdate() {
    }
  };

  // app/scripts/theme.js
  (async () => {
    customElements.define("drawer-component", Drawer);
    customElements.define("card-product", CardProduct);
    window.JobLists = new job_lists_default();
    const customerLoggedIn = localStorage.getItem("customer-logged-in");
    document.body.addEventListener("keyup", (e) => {
      e.code == "Escape" && document.querySelectorAll("popup-component.active").forEach((popup) => {
        popup.close();
      });
    });
    if (!theme.editor) {
      section.init();
    }
    theme.customer.isB2B ? await Cart.checkB2BAttributes() : await Cart.checkNonB2BAttributes();
    await Cart.checkLineItemsProperties();
    localStorage.setItem("customer-logged-in", theme.customer.isLoggedIn);
  })();
  (async () => {
    let flag = 0;
    if (!theme.customer.isB2B || theme.routes.pageType === "collection") {
      return;
    }
    if (document.querySelector("card-product")) {
      await customElements.whenDefined("card-product");
      flag++;
    }
    if (document.querySelector("card-line-item")) {
      await customElements.whenDefined("card-line-item");
      flag++;
    }
    if (document.querySelector("[data-erp-number]")) {
      flag++;
    }
    flag && PriceInventory.fetchLivePriceInventory();
  })();
})();
